window.slate = window.slate || {};
window.theme = window.theme || {};

theme.globalVar = new (function () {
  var settings = {
    headerSelector: "#shopify-section-header"
  };

  function globalVar() {
    updateGlobalVar();

    checkBrowserVersion();

    window.addEventListener("resize", function () {
      updateGlobalVar();
    });
  }

  function updateGlobalVar() {
    var windowWidth = window.innerWidth,
      headerSection = $(settings.headerSelector);

    document.documentElement.style.setProperty("--window-height", window.innerHeight + "px");

    if (headerSection && headerSection.height()) {
      document.documentElement.style.setProperty("--header-height", headerSection.height() + "px");
    } else {
      document.documentElement.style.setProperty("--header-height", "0px");
    }
  }

  function checkBrowserVersion() {
    var objappVersion = navigator.appVersion;

    var objAgent = navigator.userAgent;

    var objbrowserName = navigator.appName;

    var objfullVersion = "" + parseFloat(navigator.appVersion);

    var objBrMajorVersion = parseInt(navigator.appVersion, 10);

    var objOffsetName, objOffsetVersion, ix;

    // In Chrome

    if ((objOffsetVersion = objAgent.indexOf("Chrome")) != -1) {
      objbrowserName = "Chrome";

      objfullVersion = objAgent.substring(objOffsetVersion + 7);
    }

    // In Microsoft internet explorer
    else if ((objOffsetVersion = objAgent.indexOf("MSIE")) != -1) {
      objbrowserName = "Microsoft Internet Explorer";

      objfullVersion = objAgent.substring(objOffsetVersion + 5);
    }

    // In Firefox
    else if ((objOffsetVersion = objAgent.indexOf("Firefox")) != -1) {
      objbrowserName = "Firefox";
    }

    // In Safari
    else if ((objOffsetVersion = objAgent.indexOf("Safari")) != -1) {
      objbrowserName = "Safari";

      objfullVersion = objAgent.substring(objOffsetVersion + 7);

      if ((objOffsetVersion = objAgent.indexOf("Version")) != -1)
        objfullVersion = objAgent.substring(objOffsetVersion + 8);
    }

    // For other browser "name/version" is at the end of userAgent
    else if ((objOffsetName = objAgent.lastIndexOf(" ") + 1) < (objOffsetVersion = objAgent.lastIndexOf("/"))) {
      objbrowserName = objAgent.substring(objOffsetName, objOffsetVersion);
      objfullVersion = objAgent.substring(objOffsetVersion + 1);

      if (objbrowserName.toLowerCase() == objbrowserName.toUpperCase()) {
        objbrowserName = navigator.appName;
      }
    }

    // trimming the fullVersion string at semicolon/space if present

    if ((ix = objfullVersion.indexOf(";")) != -1) objfullVersion = objfullVersion.substring(0, ix);

    if ((ix = objfullVersion.indexOf(" ")) != -1) objfullVersion = objfullVersion.substring(0, ix);

    objBrMajorVersion = parseInt("" + objfullVersion, 10);

    if (isNaN(objBrMajorVersion)) {
      objfullVersion = "" + parseFloat(navigator.appVersion);

      objBrMajorVersion = parseInt(navigator.appVersion, 10);
    }

    $("body").addClass(objbrowserName + objBrMajorVersion);
  }

  return globalVar;
})();

var globalVar = new theme.globalVar();

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? "" : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? "" : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, "id", evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};

        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");
          return currentOption;
        }
      });
      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      updateSwatchVariant(variant);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      updateSwatchVariant(variant);
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  function updateSwatchVariant(variant) {
    // BEGIN SWATCHES
    if (variant) {
      var form = jQuery('form[action="/cart/add"]');
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find(
          '.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]'
        );
        if (radioButton && radioButton.get(0)) {
          radioButton.get(0).checked = true;
        }
      }
    }
    // END SWATCHES
  }

  return Variants;
})();

/*================ General ================*/
// Inspiration: https://www.w3.org/TR/wai-aria-practices/examples/accordion/js/accordion.js
// feature: data-allow-toggle
// Allow for each toggle to both open and close its section. Makes it possible for all sections to be closed. Assumes only one section may be open.

// feature: data-allow-multiple
// Allow for multiple accordion sections to be expanded at the same time. Assumes data-allow-toggle otherwise the toggle on open sections would be disabled.
// __________

// Ex:
// Parent
// <div id="accordionGroup" data-accordion>
// <div id="accordionGroup" data-accordion data-allow-multiple>
// <div id="accordionGroup" data-accordion data-allow-toggle></div>
//  Question
// <div data-accordion-trigger aria-expanded="true / false" aria-controls="#faq-group-{{- id -}}-{{- forloop.index -}}">
// Answer
// <div id="faq-group-{{- id -}}-{{- forloop.index -}}" data-accordion-panel>

theme.accordion = (function () {
  "use strict";

  var selectors = {
    root: "[data-accordion]",
    trigger: "[data-accordion-trigger]",
    panel: "[data-accordion-panel]"
  };

  var features = {
    allow_multiple: "[data-allow-multiple]",
    allow_toggle: "[data-allow-toggle]"
  };

  var data = {
    target_id: "aria-controls"
  };

  var states = {
    expanded: {
      attr_name: "aria-expanded",
      attr_values: {
        yes: "true",
        no: "false"
      }
    },
    disabled: {
      attr_name: "aria-disabled",
      attr_values: {
        yes: "true",
        no: "false"
      }
    }
  };

  $(selectors.root).each(function () {
    var $accordion = $(this);
    init($accordion);
  });

  function init($accordion) {
    var allowsMultiple = $accordion.is(features.allow_multiple);
    var options = {
      allowsMultiple: allowsMultiple,
      allowToggle: allowsMultiple ? allowsMultiple : $accordion.is(features.allow_toggle)
    };

    $accordion.on("click", selectors.trigger, function (e) {
      e.preventDefault();
      trigger($(this), $accordion, options);
    });

    $accordion.on("keydown", function (e) {
      handleKeyboard(event, $(this), options);
    });

    if (!options.allowToggle) {
      // Get the first expanded/ active accordion
      var $expanded = $accordion.find('[aria-expanded="true"]').first();

      // If an expanded/ active accordion is found, disable
      if ($expanded.length) {
        $expanded.setAttribute(states.disabled.attr_name, states.disabled.attr_values.yes);
      }
    } else {
      // Get all unexpanded accordion panels
      var $unexpanded = $accordion.find('[aria-expanded="false"]');
      $unexpanded.each(function () {
        var panelId = $(this).attr("aria-controls");
        hidePanel($(panelId));
      });
    }
  }

  function trigger($trigger, $accordion, options) {
    var settings = {
      allowsMultiple: options.allowsMultiple,
      allowToggle: options.allowToggle
    };

    var $targetPanel = $($trigger.attr(data.target_id));

    var isExpanded = $trigger.is("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
    var $accordionActiveTriggers = $accordion.find(
      "[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']"
    );
    var $accordionActivePanels = $accordion.find(selectors.panel);

    if (!settings.allowsMultiple && $accordionActiveTriggers.length > 0) {
      // Set the expanded state on the triggering element
      $accordionActiveTriggers.not($trigger).attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($accordionActivePanels.not($targetPanel));

      // When toggling is not allowed, clean up disabled state
      if (!settings.allowToggle) {
        $accordionActiveTriggers.removeAttr(states.disabled.attr_name);
      }
    }

    if (!isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.yes);
      // Hide the accordion sections, using aria-controls to specify the desired section
      reveilPanel($targetPanel);

      // If toggling is not allowed, set disabled state on trigger
      if (!settings.allowToggle) {
        $trigger.attr(states.disabled.attr_name, states.disabled.attr_values.yes);
      }
    } else if (settings.allowToggle && isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($targetPanel);
    }
  }

  function reveilPanel($panel) {
    $panel.slideDown(); // .removeClass('hide');
  }

  function hidePanel($panel) {
    $panel.slideUp(); //.addClass('hide');
  }

  function handleKeyboard(event, $accordion, options) {}
})();

// TODO LATER : use accordion with shortcuts (keyboard)
// Array.prototype.slice.call(document.querySelectorAll('.Accordion')).forEach(function (accordion) {

//     // Allow for multiple accordion sections to be expanded at the same time
//     var allowMultiple = accordion.hasAttribute('data-allow-multiple');
//     // Allow for each toggle to both open and close individually
//     var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

//     // Create the array of toggle elements for the accordion group
//     var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-trigger'));
//     var panels = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-panel'));

//     accordion.addEventListener('click', function (event) {
//         var target = event.target;

//         if (target.classList.contains('Accordion-trigger')) {
//             // Check if the current toggle is expanded.
//             var isExpanded = target.getAttribute('aria-expanded') == 'true';
//             var active = accordion.querySelector('[aria-expanded="true"]');

//             // without allowMultiple, close the open accordion
//             if (!allowMultiple && active && active !== target) {
//                 // Set the expanded state on the triggering element
//                 active.setAttribute('aria-expanded', 'false');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

//                 // When toggling is not allowed, clean up disabled state
//                 if (!allowToggle) {
//                 active.removeAttribute('aria-disabled');
//                 }
//             }

//             if (!isExpanded) {
//                 // Set the expanded state on the triggering element
//                 target.setAttribute('aria-expanded', 'true');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

//                 // If toggling is not allowed, set disabled state on trigger
//                 if (!allowToggle) {
//                 target.setAttribute('aria-disabled', 'true');
//                 }
//             }
//             else if (allowToggle && isExpanded) {
//                 // Set the expanded state on the triggering element
//                 target.setAttribute('aria-expanded', 'false');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
//             }

//             event.preventDefault();
//         }
//     });

//     // Bind keyboard behaviors on the main accordion container
//     accordion.addEventListener('keydown', function (event) {
//         var target = event.target;
//         var key = event.which.toString();

//         var isExpanded = target.getAttribute('aria-expanded') == 'true';
//         var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

//         // 33 = Page Up, 34 = Page Down
//         var ctrlModifier = (event.ctrlKey && key.match(/33|34/));

//         // Is this coming from an accordion header?
//         if (target.classList.contains('Accordion-trigger')) {
//         // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
//         // 38 = Up, 40 = Down
//         if (key.match(/38|40/) || ctrlModifier) {
//             var index = triggers.indexOf(target);
//             var direction = (key.match(/34|40/)) ? 1 : -1;
//             var length = triggers.length;
//             var newIndex = (index + length + direction) % length;

//             triggers[newIndex].focus();

//             event.preventDefault();
//         }
//         else if (key.match(/35|36/)) {
//             // 35 = End, 36 = Home keyboard operations
//             switch (key) {
//             // Go to first accordion
//             case '36':
//                 triggers[0].focus();
//                 break;
//                 // Go to last accordion
//             case '35':
//                 triggers[triggers.length - 1].focus();
//                 break;
//             }
//             event.preventDefault();

//         }

//         }
//     });

//     // These are used to style the accordion when one of the buttons has focus
//     accordion.querySelectorAll('.Accordion-trigger').forEach(function (trigger) {

//         trigger.addEventListener('focus', function (event) {
//         accordion.classList.add('focus');
//         });

//         trigger.addEventListener('blur', function (event) {
//         accordion.classList.remove('focus');
//         });

//     });

//     // Minor setup: will set disabled state, via aria-disabled, to an
//     // expanded/ active accordion which is not allowed to be toggled close
//     if (!allowToggle) {
//         // Get the first expanded/ active accordion
//         var expanded = accordion.querySelector('[aria-expanded="true"]');

//         // If an expanded/ active accordion is found, disable
//         if (expanded) {
//         expanded.setAttribute('aria-disabled', 'true');
//         }
//     }

// });

theme.tabs = new (function () {
  var selectors = {
    container: ".tab",
    buttons_bar: ".tab__buttons",
    buttons: ".tab__buttons__single",
    content: ".tab__content"
  };

  var modifierClasses = {
    // active_button  : "tab__buttons--overlay-active",
    active_button: "tab__buttons__single--active",
    active_content: "tab__content--active"
  };

  function tabs() {
    var $tabs = $(selectors.container);
    if (!$tabs.length) return;

    // init tabs
    $tabs.each(function () {
      init($(this));
    });

    return this;
  }

  function init($tab) {
    // Get active tab button
    var $activeButton = false;
    var $tabButtons = $tab.find(selectors.buttons);
    var $activeButtons = $tabButtons.is("." + modifierClasses.active_button);

    // if no tab buttons exist, exit.
    if (!$tabButtons.length) return;

    // if active buttons found: select first, else, assign first button as active
    if ($activeButtons.length) $activeButton = $activeButtons.first();
    else $activeButton = $tabButtons.first();

    // setup listners
    $tab.on("click", selectors.buttons, function () {
      var $button = $(this);
      if ($button.hasClass(modifierClasses.active_button)) return;

      return open($button);
    });

    open($activeButton);

    // check length
    if ($(selectors.buttons_bar).length > $(window).length)
      $(selectors.buttons_bar).addClass(modifierClasses.active_button);
  }

  function open($activeButton) {
    var $tab = $activeButton.closest(selectors.container);
    var $buttons = $tab.find(selectors.buttons);
    var $contents = $tab.find(selectors.content);

    // Rest buttons / content
    $buttons.attr("tabindex", -1);

    $buttons.removeClass(modifierClasses.active_button);
    $contents.removeClass(modifierClasses.active_content).hide();

    // Select buttons / content
    var contentId = $activeButton.attr("aria-controls");
    var $activeContent = $("#" + contentId);
    $activeButton.addClass(modifierClasses.active_button);
    $activeContent.addClass(modifierClasses.active_content).fadeIn(300);

    $activeButton.attr("tabindex", 0);
  }

  return tabs;
})();

theme.Filters = (function () {
  var constants = {
    SORT_BY: "sort_by"
  };

  var selectors = {
    mainContent: "#MainCollectionContent",
    sortSelection: "#SortBy",
    filterTag: "[data-filter-tag]"
  };

  var data = {
    sortBy: "data-default-sortby"
  };

  var _sectionSettings = {};

  function Filters(container) {
    var $container = (this.$container = $(container));
    this._sectionSettings = $container.data("sectionSettings") || {};

    this.initSort();
    this.initFilters();
  }

  Filters.prototype.initSort = function () {
    this.defaultSort = this._sectionSettings.sortBy;
    this.$sortSelect = $(selectors.sortSelection, this.$container);
    this.$sortSelect.on("change", this._onSortChange.bind(this));
  };

  Filters.prototype.initFilters = function () {
    this.$container.on("click", selectors.filterTag, this._onFilterChange.bind(this));
  };

  Filters.prototype._onFilterChange = function () {
    // var filter = this._getFilterValue();

    // // remove the 'page' parameter to go to the first page of results
    // var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

    // // only add the search parameters to the url if they exist
    // search = search !== '' ? '?' + search : '';

    // document.location.href = filter + search + selectors.mainContent;

    window.location.href = this._buildUrl();
  };

  Filters.prototype._buildFiltersUrlPart = function () {
    var filtersUrlPart = "";
    this.$container.find(selectors.filterTag).each(function () {
      if (!$(this).is(":checked")) return;

      var tagHandle = $(this).val();
      if (filtersUrlPart == "") filtersUrlPart = tagHandle;
      else filtersUrlPart += "+" + tagHandle;
    });

    return filtersUrlPart;
  };

  Filters.prototype._onSortChange = function () {
    // var sort = this._sortQuery();
    // var url = window.location.href.replace(window.location.search, '');
    // var queryStringValue = slate.utils.getParameterByName('q');
    // var query = queryStringValue !== null ? queryStringValue : '';

    // if (sort.length) {
    //     var urlStripped = url.replace(window.location.hash, '');
    //     query = query !== '' ? '?q=' + query + '&' : '?';

    //     window.location.href =
    //     urlStripped + query + sort + selectors.mainContent;
    // } else {
    //     // clean up our url if the sort value is blank for default
    //     window.location.href = url;
    // }

    window.location.href = this._buildUrl();
  };

  Filters.prototype._getSortValue = function () {
    return this.$sortSelect.val() || this.defaultSort;
  };

  Filters.prototype._sortQuery = function () {
    var sort = this._getSortValue();
    var query = "";

    if (sort !== this.defaultSort) {
      query = constants.SORT_BY + "=" + sort;
    }

    return query;
  };

  Filters.prototype._buildUrl = function () {
    var baseUrl = this._sectionSettings.collectionUrl;
    var filters = this._buildFiltersUrlPart();
    var sort = this._sortQuery();

    return baseUrl + (filters === "" ? "" : "/" + filters) + (sort === "" ? "" : "?" + sort) + selectors.mainContent;
  };

  return Filters;
})();

(function () {
  "use strict";

  var doT = {
      name: "doT",
      version: "1.1.1",
      templateSettings: {
        evaluate: /\{\$([\s\S]+?(\}?)+)\}\}/g,
        interpolate: /\{\$=([\s\S]+?)\}\}/g,
        encode: /\{\$!([\s\S]+?)\}\}/g,
        use: /\{\$#([\s\S]+?)\}\}/g,
        useParams:
          /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
        define: /\{\$##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
        defineParams: /^\s*([\w$]+):([\s\S]+)/,
        conditional: /\{\$\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
        iterate: /\{\$~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
        varname: "zerance",
        strip: true,
        append: true,
        selfcontained: false,
        doNotSkipEncoded: false
      },
      template: undefined, //fn, compile template
      compile: undefined, //fn, for express
      log: true
    },
    _globals;

  doT.encodeHTMLSource = function (doNotSkipEncoded) {
    var encodeHTMLRules = {
        "&": "&#38;",
        "<": "&#60;",
        ">": "&#62;",
        '"': "&#34;",
        "'": "&#39;",
        "/": "&#47;"
      },
      matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
    return function (code) {
      return code
        ? code.toString().replace(matchHTML, function (m) {
            return encodeHTMLRules[m] || m;
          })
        : "";
    };
  };

  _globals = (function () {
    return this || (0, eval)("this");
  })();

  /* istanbul ignore else */
  if (typeof module !== "undefined" && module.exports) {
    module.exports = doT;
  } else if (typeof define === "function" && define.amd) {
    define(function () {
      return doT;
    });
  } else {
    _globals.doT = doT;
  }

  var startend = {
      append: { start: "'+(", end: ")+'", startencode: "'+encodeHTML(" },
      split: {
        start: "';out+=(",
        end: ");out+='",
        startencode: "';out+=encodeHTML("
      }
    },
    skip = /$^/;

  function resolveDefs(c, block, def) {
    return (typeof block === "string" ? block : block.toString())
      .replace(c.define || skip, function (m, code, assign, value) {
        if (code.indexOf("def.") === 0) {
          code = code.substring(4);
        }
        if (!(code in def)) {
          if (assign === ":") {
            if (c.defineParams)
              value.replace(c.defineParams, function (m, param, v) {
                def[code] = { arg: param, text: v };
              });
            if (!(code in def)) def[code] = value;
          } else {
            new Function("def", "def['" + code + "']=" + value)(def);
          }
        }
        return "";
      })
      .replace(c.use || skip, function (m, code) {
        if (c.useParams)
          code = code.replace(c.useParams, function (m, s, d, param) {
            if (def[d] && def[d].arg && param) {
              var rw = (d + ":" + param).replace(/'|\\/g, "_");
              def.__exp = def.__exp || {};
              def.__exp[rw] = def[d].text.replace(
                new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"),
                "$1" + param + "$2"
              );
              return s + "def.__exp['" + rw + "']";
            }
          });
        var v = new Function("def", "return " + code)(def);
        return v ? resolveDefs(c, v, def) : v;
      });
  }

  function unescape(code) {
    return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
  }

  doT.template = function (tmpl, c, def) {
    c = c || doT.templateSettings;
    var cse = c.append ? startend.append : startend.split,
      needhtmlencode,
      sid = 0,
      indv,
      str = c.use || c.define ? resolveDefs(c, tmpl, def || {}) : tmpl;

    str = (
      "var out='" +
      (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : str)
        .replace(/'|\\/g, "\\$&")
        .replace(c.interpolate || skip, function (m, code) {
          return cse.start + unescape(code) + cse.end;
        })
        .replace(c.encode || skip, function (m, code) {
          needhtmlencode = true;
          return cse.startencode + unescape(code) + cse.end;
        })
        .replace(c.conditional || skip, function (m, elsecase, code) {
          return elsecase
            ? code
              ? "';}else if(" + unescape(code) + "){out+='"
              : "';}else{out+='"
            : code
            ? "';if(" + unescape(code) + "){out+='"
            : "';}out+='";
        })
        .replace(c.iterate || skip, function (m, iterate, vname, iname) {
          if (!iterate) return "';} } out+='";
          sid += 1;
          indv = iname || "i" + sid;
          iterate = unescape(iterate);
          return (
            "';var arr" +
            sid +
            "=" +
            iterate +
            ";if(arr" +
            sid +
            "){var " +
            vname +
            "," +
            indv +
            "=-1,l" +
            sid +
            "=arr" +
            sid +
            ".length-1;while(" +
            indv +
            "<l" +
            sid +
            "){" +
            vname +
            "=arr" +
            sid +
            "[" +
            indv +
            "+=1];out+='"
          );
        })
        .replace(c.evaluate || skip, function (m, code) {
          return "';" + unescape(code) + "out+='";
        }) +
      "';return out;"
    )
      .replace(/\n/g, "\\n")
      .replace(/\t/g, "\\t")
      .replace(/\r/g, "\\r")
      .replace(/(\s|;|\}|^|\{)out\+='';/g, "$1")
      .replace(/\+''/g, "");
    //.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

    if (needhtmlencode) {
      if (!c.selfcontained && _globals && !_globals._encodeHTML)
        _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
      str =
        "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (" +
        doT.encodeHTMLSource.toString() +
        "(" +
        (c.doNotSkipEncoded || "") +
        "));" +
        str;
    }
    try {
      return new Function(c.varname, str);
    } catch (e) {
      /* istanbul ignore else */
      if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
      throw e;
    }
  };

  doT.compile = function (tmpl, def) {
    return doT.template(tmpl, null, def);
  };
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]"
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    $(selectors.productJson);
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var self = this;
    $("[data-price-wrapper] input").click(function () {
      self.updateRechargeProductButtonPrice();
    });

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src"));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateRechargeProductButtonPrice: function () {
      console.log("Update recharge product button price");
      var rechargeProductPriceString = "";
      if ($("[data-recharge-product-price]").length) {
        if ($("[data-price-wrapper] input:checked").next().find(".product__price .money").html()) {
          rechargeProductPriceString =
            $("[data-price-wrapper] input:checked").next().find(".product__price .money").html() + " - ";
        } else if ($("[data-price-wrapper] input:checked").next().find(".product__price").html()) {
          rechargeProductPriceString =
            $("[data-price-wrapper] input:checked").next().find(".product__price").html() + " - ";
        }
      }

      var addToCartText = theme.strings.addToCart;
      if ($("#product_recharge").is(":checked")) addToCartText = "S'abonner";

      $(selectors.addToCartText, this.$container).html(
        '<span class="hide" data-recharge-product-price>' + rechargeProductPriceString + "</span>" + addToCartText
      );
    },

    updateAddToCartState: function (evt) {
      console.log("here");
      var variant = evt.variant;
      updateSelectedVariant(variant);

      if (variant) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.priceWrapper, this.$container).addClass("hide");
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        return;
      }

      $("[data-product-add-to-cart]").each(function () {
        $(this).attr("data-product-add-to-cart", variant.id);
        $(this).next().attr("data-variant-id", variant.id);
      });

      if (variant.available) {
        $("[data-product-add-to-cart]").each(function () {
          $(this).prop("disabled", false);
          $(this).prop("type", "submit");
        });
        var addToCartText = theme.strings.addToCart;
        if ($("#product_recharge :checked").length > 0) addToCartText = "S'abonner";

        $(selectors.addToCartText, this.$container).html(
          '<span class="hide" data-recharge-product-price></span>' + addToCartText
        );
      } else {
        $("[data-product-add-to-cart]").each(function () {
          $(this).prop("disabled", true);
          $(this).prop("type", "button");
        });
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
      this.updateRechargeProductButtonPrice();
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var qty = $("[data-product-quantity]").val();

      var $currentVariant = $("[data-product-select] option:selected");
      var currentVariantDiscountPrice = $currentVariant.data("discount-variant-price");

      if (currentVariantDiscountPrice != "" || currentVariantDiscountPrice != undefined) {
        currentVariantDiscountPrice = currentVariantDiscountPrice * qty;
        currentVariantDiscountPrice = currentVariantDiscountPrice.toFixed(2) + "€";
        $("[data-product-price-recharge]").text(currentVariantDiscountPrice.replace(".", ",").replace(",00", ""));
      }

      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      var variantPrice = variant.price * qty;
      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variantPrice, theme.moneyFormat).replace(",00", "")
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
      this.updateRechargeProductButtonPrice();
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;

      var $selectedCell = $('[data-image-id="' + variant.featured_image.id + '"]');
      if ($selectedCell.length > 0) {
        $selectedCell.click();
      } else {
        $("[data-product-image]").attr("src", variant.featured_image.src);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/** update swatch with current variant **/
if (typeof variable !== "undefined") {
  if (variant) {
    var form = jQuery('form[action="/cart/add"]');
    for (var i = 0, length = variant.options.length; i < length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
      if (radioButton.lenth && radioButton.lenth != 0) {
        radioButton.get(0).checked = true;
      }
    }
  }
}

//  ADD TO CART

function addToCartSimple(variantId, quantity) {
  $("[data-product-add-to-cart]").each(function () {
    $(this).prop("disabled", true);
  });
  data = {
    id: variantId,
    quantity: parseInt(quantity)
  };
  addToCartJquery(data);
}

function addToCartRecharge() {
  // console.log("Add to cart - Recharge");
  var productSelected = $("[data-product-select] option:selected");
  var id = productSelected.data("discount-variant-id");
  var subscription_id = $("[data-subscription-id]").data("subscription-id");
  var shippingIntervalFrequency = $("[data-product-subscription-frequency]:checked").val();
  var shippingIntervalUnitType = $("[data-shipping-interval-unit-type]").attr("data-shipping-interval-unit-type");
  var qty = $("[data-product-quantity]");
  qty = $(qty).val();

  data = {
    id: id,
    quantity: qty,
    properties: {
      subscription_id: subscription_id,
      shipping_interval_frequency: shippingIntervalFrequency,
      shipping_interval_unit_type: shippingIntervalUnitType
    }
  };

  addToCartJquery(data);
}

function addToCartJquery(data) {
  var settings = {
    quickView: "[data-quick-view]",
    quickViewOverlay: "[data-quick-view-overlay]",
    quickViewContent: "[data-quick-view-content]"
  };

  $(settings.quickViewContent).html("");
  $(settings.quickView).removeClass("active");
  $(settings.quickViewOverlay).removeClass("active");

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      $(document).trigger("cart.requestDone");
      $("[data-product-add-to-cart]").each(function () {
        $(this).prop("disabled", false);
      });
    },
    error: function (err) {
      alert(err.responseJSON["description"]);
      $("[data-product-add-to-cart]").each(function () {
        $(this).prop("disabled", false);
      });
    }
  });
}

// notify me button

$("[data-product-add-to-cart]")
  .on("rightnow change", function () {
    if ($("[data-product-add-to-cart]").is("[disabled]")) {
      $("#BIS_trigger").show();
    } else {
      $("#BIS_trigger").hide();
    }
  })
  .triggerHandler("rightnow");

/** header **/

theme.header = new (function () {
  var settings = {};
  var lastScrollTop = 0;

  function header(headerSettings) {
    // init default settings
    var defaultSettings = {
      bodySelector: "body",
      nonScrollClass: "non-scroll",
      headerId: "shopify-section-header",
      headerSelector: ".header",
      headerTransparent: "header--transparent",
      headerSubmenu: ".header__submenu",
      headerTransparentClass: ".header--transparent",
      toggleSideNav: "[data-header-toggle]",
      sideNavSelector: "[data-header-side-nav]",
      sideNavBackground: "[data-header-side-nav-background]",
      openSideNavClass: "active",
      sideNavSubmenu: "[data-submenu]",
      headerMenuItem: ".header__menu-item"
    };

    // merge settings
    settings = $.extend({}, defaultSettings, headerSettings);

    $(function () {
      $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();
        if ($(settings.headerSubmenu).height() > 0) {
          if ($(settings.headerSelector).hasClass("header--white")) {
          }
        } else if (scrollTop == 0) {
          $(settings.headerTransparentClass).addClass("light");
          if ($(settings.headerSelector).hasClass("header--white")) {
          }
        }
      });
    });

    $(settings.toggleSideNav).on("click", function () {
      toggleSideNav();
    });
    $(".header__side-menu-hover").on("mouseenter", function () {
      toggleSideNav();
    });

    $(settings.sideNavBackground).on("click", function () {
      closeSideNav();
    });

    updateHeader();
    $(window).scroll(function () {
      updateHeader();
    });

    $(settings.sideNavSubmenu).on("click", function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });
  }

  function openSideNav() {
    $(settings.headerSelector).addClass("side-nav-open");
    $(".side-nav__container").addClass(settings.openSideNavClass);
    $(settings.sideNavSelector).addClass(settings.openSideNavClass);
    $("body").addClass("inactive");
    $(settings.bodySelector).addClass(settings.nonScrollClass);
  }

  function closeSideNav() {
    $(".side-nav__container").removeClass(settings.openSideNavClass);
    setTimeout(function () {
      $(settings.headerSelector).removeClass("side-nav-open");
      $(settings.sideNavSelector).removeClass(settings.openSideNavClass);
    }, 400);
    $("body").removeClass("inactive");
    $(settings.bodySelector).removeClass(settings.nonScrollClass);
  }

  function checkHeaderStatus() {
    if ($(window).scrollTop() > 50) {
      if ($(settings.headerSelector).hasClass("header--white")) {
        $(settings.headerSelector).removeClass("white");
      }
    } else {
      $(settings.headerSelector).addClass("light");
      if ($(settings.headerSelector).hasClass("header--white")) {
        $(settings.headerSelector).addClass("white");
      }
    }
  }

  function toggleSideNav() {
    if ($(settings.sideNavSelector).hasClass(settings.openSideNavClass)) closeSideNav();
    else openSideNav();
  }

  function updateHeader() {
    if ($(window).scrollTop() > 300) {
      $(".header__logo-image").addClass("header__logo--scroll");
    }
    if ($(window).scrollTop() < 200) {
      $(".header__logo-image").removeClass("header__logo--scroll");
    }
  }

  return header;
})();

var header = new theme.header();

theme.banner = new (function () {
  var settings = {};
  var typeAnimationArray = [];

  function banner(bannerSettings) {
    var defaultSettings = {
      headerSelector: "#shopify-section-header",
      bannerSelector: "[data-banner]",
      selectorData: "banner",
      prevNextButtons: false,
      pageDots: false,
      autoplay: false,
      fade: false
    };
    if ($(window).width() > 787) defaultSettings.fade = true;

    $(document).ready(function () {
      resizeWindow();
    });

    window.addEventListener("resize", function () {
      resizeWindow();
    });

    settings = $.extend({}, defaultSettings, bannerSettings);

    $(settings.bannerSelector).each(function () {
      var el = $(this);
      var sectionId = $(this).data("banner-section-id");

      $(this).imagesLoaded(function () {
        var elementSettings = $(el).data(settings.selectorData);
        var finalSettings = $.extend({}, settings, elementSettings);
        console.log("Final settings", finalSettings);
        $(el).flickity({
          lazyLoad: "true",
          pageDots: finalSettings.pageDots,
          prevNextButtons: finalSettings.prevNextButtons,
          autoPlay: finalSettings.autoPlay,
          fade: finalSettings.fade,
          wrapAround: finalSettings.wrapAround,
          on: {
            ready: function () {
              var typeText = $("[data-banner-type-text]")[0];
              text = $(typeText).attr("data-banner-type-text");
              typeAnimation(sectionId + "-" + 0, text, false);
              typeAnimationArray.push(sectionId + "-" + 0);
            },
            change: function (index) {
              var slide = sectionId + "-" + index;
              var typeText = $("[data-banner-type-text]")[index];
              text = $(typeText).attr("data-banner-type-text");
              if (!typeAnimationArray.includes(slide)) {
                typeAnimationArray.push(slide);
                typeAnimation(sectionId + "-" + index, text, false);
              } else {
                typeAnimation(sectionId + "-" + index, text, true);
              }
            }
          }
        });
      });
    });
  }

  function resizeWindow() {
    var windowWidth = window.innerWidth,
      headerSection = $(settings.headerSelector);

    document.documentElement.style.setProperty("--window-height", window.innerHeight + "px");
    if (headerSection && headerSection.height()) {
      document.documentElement.style.setProperty("--header-height", headerSection.height() + "px");
    } else {
      document.documentElement.style.setProperty("--header-height", "0px");
    }

    if ($(".header--transparent").length > 0) {
      var headerTransparent = $(".header--transparent").height();
      document.documentElement.style.setProperty("--header-transparent", headerTransparent + "px");
    } else {
      document.documentElement.style.setProperty("--header-transparent", "70px");
    }
  }

  return banner;
})();

var banner = new theme.banner();

theme.cart = new (function () {
  var settings = {};

  function cart(cartSettings) {
    // init default settings
    var defaultSettings = {
      bodySelector: "body",
      nonScrollClass: "non-scroll",
      openCartSelector: "[data-cart-open]",
      toggleCartSelector: "[data-cart-toggle]",
      closeCartSelector: "[data-cart-close]",
      cartSelector: "[data-side-cart]",
      cartItemSelector: "[data-cart-item]",
      cartItemsSelector: "[data-cart-items]",
      cartItemRemoveSelector: "[data-cart-item-remove]",
      cartTotalPriceSelector: "[data-cart-total-price]",
      cartFooterSelector: "[data-cart-footer]",
      updateCartSelector: "[data-add-to-cart]",
      cartBackground: "[data-cart-background]",
      openCartClass: "open",
      activeBackgroundClass: "active",
      cartEmpty: "[data-cart-empty]",
      cartNotEmpty: "[data-cart-not-empty]",
      headerSelector: ".header",
      headerNotLight: "not-light",
      cartAddRecharge: "[data-cart-add-recharge]",
      cartItemsResult: "[data-cart-items-result]",
      cartLoading: "[data-cart-loading ]",
      // Free shipping
      freeShippingContainer: "[data-free-shipping]",
      freeShippingBar: "[data-free-shipping-bar]",
      freeShippingUnavailable: "[data-free-shipping-unavailable]",
      freeShippingAvailable: "[data-free-shipping-available]",
      freeShippingProgress: ".free-shipping__progress-content",
      // Free shipping2
      freeShippingContainer2: "[data-free-shipping2]",
      freeShippingBar2: "[data-free-shipping-bar2]",
      rewardBar1: "[data-free-shipping-bar2-1]",
      rewardBar2: "[data-free-shipping-bar2-2]",
      rewardBar3: "[data-free-shipping-bar2-3]",
      rewardTitle1: "[data-free-shipping-bar2-1-name]",
      rewardTitle2: "[data-free-shipping-bar2-2-name]",
      rewardTitle3: "[data-free-shipping-bar2-3-name]",
      freeItemId: "[data-cart-free]",

      freeShippingUnavailable2: "[data-free-shipping-unavailable2]",
      freeShippingProgress2: ".free-shipping__progress-content2",
      firstReward: ".first-bar",
      secondReward: ".second-bar",
      thirdReward: ".third-bar",
      // Related product
      relatedProductSubmit: "[data-related-product-submit]"
    };
    // merge settings
    settings = $.extend({}, defaultSettings, cartSettings);

    // init cart
    $(document).on("cart.ready", function (event, cart) {
      constructCart(cart, false);
    });

    // call classic function on click on trigger elemets
    $(settings.toggleCartSelector).on("click", function () {
      toggleCart();
      return false;
    });

    $("body").on("click", settings.closeCartSelector, function () {
      closeCart();
      return false;
    });

    $(settings.cartBackground).on("click", function () {
      $(this).hide();
      closeCart();
      return false;
    });

    $(settings.openCartSelector).on("click", function () {
      openCart();
      return false;
    });

    $(document).on("cart.requestComplete", function (event, cart) {
      constructCart(cart, true);
    });

    $("body").on("click", settings.cartAddRecharge, function (event) {
      event.preventDefault();
      var counterContainer = $(this).closest(".counter__container");
      var qty = counterContainer.find(".cart-item__qty-item").text().trim();
      $(settings.cartLoading).show();
      $this = $(this);
      addRechargeProduct($this, qty);
    });

    $("body").on("click", "[data-item-update]", async function (e) {
      e.preventDefault();
      $(settings.cartLoading).show();
      var key = $(this).attr("data-item-update");
      const packId = $(this).attr("data-item-pack") || "false";

      if (packId !== "false") {
        console.log({ packId });

        const cart = await (await fetch("/cart.js")).json();
        console.log(cart.items);
        const updates = cart.items.reduce((acc, item) => {
          if (item.properties?.deduplicationId == packId) {
            acc[item.id] = 0;
          }
          return acc;
        }, {});

        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates
          })
        });
        $(document).trigger("cart.requestDone");
        console.log("result", await res.json());
      } else {
        var qty = $(this).attr("data-item-quantity");
        jQuery.post("/cart/update.js", "updates[" + key + "]=" + qty).done(function () {
          $(document).trigger("cart.requestDone");
        });
      }
    });

    $("body").on("click", "[data-related-product-submit]", function () {
      var variantId = $(this).data("related-product-submit");
      if (variantId != undefined) {
        $(settings.cartLoading).show();
        $(this).closest(".cart-item").slideToggle();
        setTimeout(function () {
          $(settings.cartItemsResult).scrollTop(0);
        }, 1000);
        addToCartSimple(variantId, 1);
      } else {
        alert(
          "Une erreur est survenue, merci de rafraichir la page. Si le probleme persiste, vous pouvez contacter le support."
        );
      }
    });

    $(document).on("cart.requestDone", function (event) {
      event.preventDefault();
      $(settings.cartLoading).show();
      jQuery.getJSON("/cart", function (cart) {
        // $(settings.cartLoaderSelector).hide();
        constructCart(cart, true);
      });
    });
  }

  //Free shipping
  function updateFreeShipping(cart_total) {
    $(settings.freeShippingContainer).removeClass("active");
    if ($(settings.freeShippingContainer).length > 0) {
      var value = $(settings.freeShippingBar).data("free-shipping-bar");
      var total = cart_total.substring(0, cart_total.length - 1);

      var valueToFreeShipping = parseFloat(value - total);
      if (valueToFreeShipping < 0) valueToFreeShipping = 0;
      valueToFreeShipping = Number(valueToFreeShipping).toFixed(2);
      valueToFreeShipping = valueToFreeShipping.replace(".00", "").replace(".", ",");

      var percent = (parseInt(total) / value) * 100;
      if (percent > 100) percent = 100;

      var need = 100 - percent;
      if (need < 0) need = 0;
      need = Number(need).toFixed(2);
      need = need.replace(".00", "");

      if (percent >= 100) {
        $(settings.freeShippingUnavailable).hide();
        $(settings.freeShippingAvailable).show();
      } else {
        $(settings.freeShippingAvailable).hide();
        $(settings.freeShippingUnavailable + " span").text(valueToFreeShipping);
        $(settings.freeShippingUnavailable).show();
      }
      $(settings.freeShippingContainer).addClass("active");
      $(settings.freeShippingProgress).css("width", percent + "%");
    }
  }

  //Free shipping2
  function updateFreeShipping2(cart_total2) {
    $(settings.freeShippingContainer2).removeClass("active");
    if ($(settings.freeShippingContainer2).length > 0) {
      var value = $(settings.freeShippingBar2).data("free-shipping-bar2");
      var total = cart_total2.substring(0, cart_total2.length - 1);

      var valueToFreeShipping = parseFloat(value - total);
      if (valueToFreeShipping < 0) valueToFreeShipping = 0;
      valueToFreeShipping = Number(valueToFreeShipping).toFixed(2);
      valueToFreeShipping = valueToFreeShipping.replace(".00", "").replace(".", ",");

      var percent = (parseInt(total) / value) * 100;
      if (percent > 100) percent = 100;

      var need = 100 - percent;
      if (need < 0) need = 0;
      need = Number(need).toFixed(2);
      need = need.replace(".00", "");

      if (percent >= 100) {
        $(settings.freeShippingUnavailable2).hide();
        $(settings.freeShippingAvailable2).show();
      } else {
        $(settings.freeShippingAvailable2).hide();
        $(settings.freeShippingUnavailable2 + " span").text(valueToFreeShipping);
        $(settings.freeShippingUnavailable2).show();
      }
      $(settings.freeShippingContainer2).addClass("active");
      $(settings.freeShippingProgress2).css("width", percent + "%");
    }
  }

  function updateMessage(from) {
    var upMessage = $("[data-cart_up_message]").data("data-cart_up_message");
    var downMessage = $("[data-cart_down_message]").data("cart_down_message");
    var initMessage = $("[data-cart_initiative_message]").data("cart_initiative_message").split("{X}");
    var currentMessage = "";
    var tempMessage = "";

    if (tracker.index == tracker.currentlyAt.length - 1 && tracker[tracker.currentlyAt[tracker.index]].from == 100) {
      console.log("HERE HERE HERE");
      console.log("HERE HERE HERE");
      console.log("HERE HERE HERE");

      currentMessage = "Vous avez obtenu toutes les récompenses possibles !";
      setTimeout(() => {
        $(".free-shipping__wrapper").hide();
        resizeCart();
      }, 2000);
    } else if (tracker.currentlyAt[tracker.index] == "first") {
      currentMessage =
        initMessage[0] +
        (tracker.first.amount - tracker.total) +
        initMessage[1] +
        $(settings.rewardTitle1).data("free-shipping-bar2-1-name");
    } else if (tracker.currentlyAt[tracker.index] == "second") {
      currentMessage =
        "Plus que <b>" +
        (tracker.second.amount - tracker.total) +
        "€ </b> pour profiter de la " +
        $(settings.rewardTitle2).data("free-shipping-bar2-2-name");
    } else if (tracker.currentlyAt[tracker.index] == "third") {
      currentMessage =
        "Plus que <b>" +
        (tracker.third.amount - tracker.total) +
        "€ </b> pour profiter de la " +
        $(settings.rewardTitle2).data("free-shipping-bar2-3-name");
    }
    if (from) {
      $(".free-shipping__text").css("transition", "all 1s");
      $(".free-shipping__text").css("opacity", 0);
      setTimeout(() => {
        if (from == 100) {
          tempMessage = "Vous avez renoncé " + tracker[tracker.currentlyAt[tracker.index]].reward;
        } else {
          tempMessage = "Vous avez obtenu " + tracker[tracker.currentlyAt[tracker.index]].reward;
        }
        $(".free-shipping__text").html(tempMessage);
        $(".free-shipping__text").css("opacity", 1);
        setTimeout(() => {
          $(".free-shipping__text").css("opacity", 0);
          setTimeout(() => {
            $(".free-shipping__text").css("opacity", 1);
            $(".free-shipping__text").html(currentMessage);
          }, 1000);
        }, 2000);
      }, 1000);
    } else {
      $(".free-shipping__text").html(currentMessage);
      $(".free-shipping__text").show();
    }
  }

  function barMovement(from, to) {
    $(".free-shipping__wrapper").show();
    if (from == 100 || from == 0) {
      setTimeout(() => {
        $(settings.firstReward).css({ transition: "all 0s ease" });
        $(settings.firstReward).css("width", from + "%");
      }, 700);
      setTimeout(() => {
        $(settings.firstReward).css("transition", "all 0.7s ease");
        $(settings.firstReward).css("width", to + "%");
      }, 750);
    } else {
      $(settings.firstReward).css("width", to + "%");
    }
    if (to < 0) {
      tracker[tracker.currentlyAt[tracker.index]].from = 0;
      tracker.index = tracker.index - 1;
      $(".free-shipping__price").html(tracker[tracker.currentlyAt[tracker.index]].amount + "€");
      barMovement(100, tracker[tracker.currentlyAt[tracker.index]].value);
      if (tracker.index > 0) {
        $("#gift_icon").addClass("is-active");
        $("#shipping_icon").removeClass("is-active");
      } else {
        $("#gift_icon").removeClass("is-active");
        $("#shipping_icon").addClass("is-active");
      }
      updateMessage(100);
    } else if (to > 100 && tracker.index != tracker.currentlyAt.length - 1) {
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);
      console.log(tracker.index);

      tracker[tracker.currentlyAt[tracker.index]].from = 100;
      tracker.index = tracker.index + 1;
      $(".free-shipping__price").html(tracker[tracker.currentlyAt[tracker.index]].amount + "€");
      barMovement(0, tracker[tracker.currentlyAt[tracker.index]].value);
      updateMessage(1);
      if (tracker.index > 0) {
        $("#gift_icon").addClass("is-active");
        $("#shipping_icon").removeClass("is-active");
      } else {
        $("#gift_icon").removeClass("is-active");
        $("#shipping_icon").addClass("is-active");
      }
    } else if (to > 100 && tracker.index == tracker.currentlyAt.length - 1) {
      tracker[tracker.currentlyAt[tracker.index]].from = 100;
      updateMessage();
    } else if (tracker.index == tracker.currentlyAt.length - 1 && from == 100 && to < 100) {
      tracker[tracker.currentlyAt[tracker.index]].from = to;
      updateMessage(100);
      if (tracker.index > 0) {
        $("#gift_icon").addClass("is-active");
        $("#shipping_icon").removeClass("is-active");
      } else {
        $("#gift_icon").removeClass("is-active");
        $("#shipping_icon").addClass("is-active");
      }
    } else {
      tracker[tracker.currentlyAt[tracker.index]].from = to;
      updateMessage();
    }
  }

  var tracker = {
    first: {
      from: 0,
      value: 0,
      reward: $(settings.rewardTitle2).data("free-shipping-bar2-1-name"),
      amount: ""
    },
    second: {
      from: 0,
      value: 0,
      reward: $(settings.rewardTitle2).data("free-shipping-bar2-2-name"),
      amount: ""
    },
    third: {
      from: 0,
      value: 0,
      reward: $(settings.rewardTitle2).data("free-shipping-bar2-3-name"),
      amount: ""
    },
    currentlyAt: [],
    index: 0,
    total: ""
  };

  console.log(tracker);
  console.log(tracker);
  console.log(tracker);

  //Free shipping3
  function updateFreeShipping3(cart_total2) {
    if (tracker.index > 0) {
      $("#gift_icon").addClass("is-active");
      $("#shipping_icon").removeClass("is-active");
    } else {
      $("#gift_icon").removeClass("is-active");
      $("#shipping_icon").addClass("is-active");
    }
    $(".free-shipping__text").show();
    $(settings.freeShippingContainer2).removeClass("active");
    if ($(settings.freeShippingContainer2).length > 0) {
      tracker.first.amount = parseInt($(settings.rewardBar1).data("free-shipping-bar2-1"));
      tracker.second.amount = parseInt($(settings.rewardBar2).data("free-shipping-bar2-2"));
      tracker.third.amount = parseInt($(settings.rewardBar3).data("free-shipping-bar2-3"));
      tracker.first.reward = $("[data-free-shipping-bar2-1-name]").data("free-shipping-bar2-1-name");
      tracker.second.reward = $("[data-free-shipping-bar2-2-name]").data("free-shipping-bar2-2-name");
      tracker.third.reward = $("[data-free-shipping-bar2-3-name]").data("free-shipping-bar2-3-name");

      tracker.total = parseInt(cart_total2.substring(0, cart_total2.length - 1));
      tracker.first.value = (tracker.total / tracker.first.amount) * 100;
      tracker.second.value =
        ((tracker.total - tracker.first.amount) / (tracker.second.amount - tracker.first.amount)) * 100;
      tracker.third.value =
        ((tracker.total - tracker.second.amount) / (tracker.third.amount - tracker.second.amount)) * 100;
      var currentMessage;
      if (tracker.first.amount) {
        tracker.currentlyAt = [...tracker.currentlyAt, "first"];
      }
      if (tracker.second.amount) {
        tracker.currentlyAt = [...tracker.currentlyAt, "second"];
      }
      if (tracker.third.amount) {
        tracker.currentlyAt = [...tracker.currentlyAt, "third"];
      }
      -$(settings.freeShippingContainer2).addClass("active");
      barMovement(tracker[tracker.currentlyAt[tracker.index]].from, tracker[tracker.currentlyAt[tracker.index]].value);
      $(".free-shipping__text").html(currentMessage);
      $(".free-shipping__text").show();
      $(settings.firstReward).removeClass("is-active");
      $(settings.secondReward).removeClass("is-active");
      $(settings.thirdReward).removeClass("is-active");
      $(settings.firstReward).addClass("is-active");
    }
  }

  function getPrice(price, cart) {
    var price = Number(price / 100).toFixed(2);
    // price.remove(".00");
    if (cart.currency == "EUR") return price + "€";
    else return price + "$";
  }

  async function constructCart(cart, open) {
    $(settings.cartLoading).show();
    // create elements
    var items = [];
    var c = null;

    var findSubscription = false;

    const count = cart.items.reduce((acc, item) => {
      if (item.properties.packId) {
        return acc;
      } else {
        return (acc += item.quantity);
      }
    }, 0);
    $(".header__cart-count span").text(count);

    $("[data-cart-button]").prop("disabled", "disabled");
    for (var i = 0, l = cart.items.length; i < l; i++) {
      c = cart.items[i];
      var uid = null;
      var bundle_price = null;
      var discounted_price = null;
      var bundle = null;
      if (c?.properties) {
        bundle_price = c.properties.bundle_price;
        uid = c.properties.uid;
        bundle = c.properties.bundle;
        discounted_price =
          parseFloat(c.properties.bundle_price) -
          (parseFloat(c.properties.bundle_price) * parseFloat(c.properties.bundle_discount)) / 100;
      }

      var context = {
        item_handle: c.handle,
        item_image: c.image,
        item_product_suptitle: "",
        item_variant_title: c.variant_title,
        item_variant_id: c.variant_id,
        item_product_title: c.product_title,
        item_product_description: "",
        item_price: getPrice(c.price, cart).replace(".", ","),
        item_quantity: c.quantity,
        item_quantity_plus: c.quantity + 1,
        item_quantity_minus: c.quantity - 1,
        item_line_price: getPrice(c.line_price, cart).replace(".", ","),
        item_url: c.url,
        item_status: "oneshot",
        item_subscription_id: "",
        item_discount_variant_id: "",
        item_property: null,
        item_key: c.key,
        item_propertyUid: uid,
        item_propertyBundle: bundle,
        item_propertyBundlePrice: bundle_price,
        item_propertyDeduplicationId: c.properties.deduplicationId,
        item_propertyIsPack: !c.properties.packId && !!c.properties.deduplicationId,

        item_propertyPackId: c.properties.packId,
        item_propertyBundleDiscount: discounted_price
      };

      if (!!c.properties.packId && !!c.properties.deduplicationId) {
        // is a line item
        continue;
      }
      // is pack
      if (!c.properties.packId && !!c.properties.deduplicationId) {
        context.item_isPack = true;
        var formatter = new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR"
        });
        const itemsInPack = cart.items.filter(
          (item) => item.properties.deduplicationId === c.properties.deduplicationId && !!item.properties.packId
        );

        context.item_line_price_discounted = formatter.format(
          itemsInPack.reduce((acc, value) => {
            acc = acc + (value.line_price + value.line_level_total_discount) / 100;
            return acc;
          }, 0)
        );
        context.item_line_price = formatter.format(
          itemsInPack.reduce((acc, value) => {
            acc = acc + value.line_price / 100;
            return acc;
          }, 0)
        );
        context["pack_items"] = itemsInPack.map((item) => ({
          title: item.variant_title,
          originalPrice: formatter.format(item.original_price / 100),
          finalPrice: formatter.format(item.final_line_price / 100),
          image: item.image,
          quantity: item.quantity
        }));
      }

      var item = await getProductMetafields(context.item_handle);
      
      var data = item["data"]["productByHandle"];
      console.log('data :', data);
      var is_sub = 0;
      $("[data-cart-button]").prop("disabled", false);

      try {
        var frequency = c.properties["shipping_interval_frequency"];
      } catch (error) {
        var frequency = 0;
      }

      if (data != null) {
        for (var m = 0; m < data["metafields"]["edges"].length; m++) {
          var currentProductMetafield = data["metafields"]["edges"][m];
          if (currentProductMetafield["node"]["namespace"] == "subscriptions") {
            if (is_sub == 0) {
              context.item_status = "not-subscribed";
              is_sub = 1;
            }
            if (currentProductMetafield["node"]["key"] == "subscription_id") {
              context.item_subscription_id = currentProductMetafield["node"]["value"];
            } else if (currentProductMetafield["node"]["key"] == "shipping_interval_unit_type") {
              context.item_shipping_interval_unit_type = currentProductMetafield["node"]["value"];
            } else if (currentProductMetafield["node"]["key"] == "original_handle") {
              context.item_status = "subscribed";
              findSubscription = true;
            }
            context.item_shipping_interval_frequency = 1;
          } else {
            if (currentProductMetafield["node"]["key"] == "title") {
              context.item_product_title = currentProductMetafield["node"]["value"];
            } else if (currentProductMetafield["node"]["key"] == "suptitle") {
              context.item_product_suptitle = currentProductMetafield["node"]["value"];
            } else if (currentProductMetafield["node"]["key"] == "description_cart") {
              context.item_product_description = currentProductMetafield["node"]["value"];
              console.log("Frequency ", frequency);
              if (frequency) {
                var newDesc = context.item_product_description + "<br> Tous les " + frequency + " mois";
                context.item_product_description = newDesc;
              }
            } else if (currentProductMetafield["node"]["key"] == "image") {
              context.item_image = currentProductMetafield["node"]["value"];
            }
          }
        }

        if (context.item_product_description == "") {
          for (var n = 0; n < data["metafields"]["edges"].length; n++) {
            var currentProductMetafield = data["metafields"]["edges"][n];
            if (currentProductMetafield["node"]["key"] == "description") {
              context.item_product_description = currentProductMetafield["node"]["value"];
            }
            console.log("Frequency ", frequency);
            if (frequency) {
              var newDesc = context.item_product_description + "<br> Tous les " + frequency + " mois";
              context.item_product_description = newDesc;
            }
          }
        }

        var variants = data["variants"]["edges"];
        if (variants.length > 1) {
          for (var j = 0; j < variants.length; j++) {
            if (context.item_variant_title == variants[j]["node"]["title"]) {
              var currentVariant = variants[j]["node"];
              if (currentVariant["metafields"]["edges"].length > 0) {
                var currentMetafields = currentVariant["metafields"]["edges"];
                for (var k = 0; k < currentMetafields.length; k++) {
                  if (currentMetafields[k]["node"]["key"] == "title") {
                    context.item_product_title = currentMetafields[k]["node"]["value"];
                  } else if (currentMetafields[k]["node"]["key"] == "suptitle") {
                    context.item_product_suptitle = currentMetafields[k]["node"]["value"];
                  } else if (currentMetafields[k]["node"]["key"] == "description_cart") {
                    context.item_product_description = currentMetafields[k]["node"]["value"];
                    console.log("Frequency ", frequency);
                    if (frequency) {
                      var newDesc = context.item_product_description + "<br> Tous les " + frequency + " mois";
                      context.item_product_description = newDesc;
                    }
                  } else if (currentMetafields[k]["node"]["key"] == "image") {
                    context.item_image = currentMetafields[k]["node"]["value"];
                  } else if (currentMetafields[k]["node"]["key"] == "discount_variant_id") {
                    context.item_discount_variant_id = currentMetafields[k]["node"]["value"];
                  } else if (currentMetafields[k]["node"]["key"] == "property") {
                    context.item_property = currentMetafields[k]["node"]["value"];
                  }
                }
              }
            }
          }
        }
      }

      items.push(context);
    }

    $(settings.cartTotalPriceSelector).html(getPrice(cart.total_price, cart));

    if (cart.items.length > 0) {
      var height = $(window).outerHeight() + "px";
      var cartHeaderHeight = $(".cart-header").outerHeight() + "px";
      var cartFooterHeight = $(".cart-footer").outerHeight() + "px";
      $(settings.cartFooterSelector).removeClass("hide");
      $(".cart-addition").removeClass("hide");
      $(settings.cartNotEmpty).removeClass("hide");
      $("#CartCount").removeClass("hide");
      $(settings.cartEmpty).addClass("hide");
      if ($("#cart-items").length != 0 && $("#cart-items__result").length != 0) {
        updateCartItems(items);
      }
    } else {
      $(settings.cartFooterSelector).addClass("hide");
      $(".cart-addition").addClass("hide");
      $(settings.cartEmpty).removeClass("hide");
      $(settings.cartNotEmpty).addClass("hide");
      // $(settings.cartItemsSelector).html(settings.emptyCartText);
    }

    if (findSubscription) {
      try {
        // Cross-domain tracking with Google Analytics
        var ga_linker = ga.getAll()[0].get("linkerParam");
      } catch (e) {
        // 'ga' is not available
        // console.log('GA Failed');
        var ga_linker = "";
      }

      var token = reChargeGetCookie("cart");
      var myshopify_domain = "synergicnutrition.myshopify.com";
      // Customer email address for use in the Checkout URL
      var customer_param = "";
      var customer_id = $("[data-customer]").attr("[data-customer-id]");
      var customer_email = $("[data-customer]").attr("[data-customer-mail]");
      if (customer_id && customer_email)
        customer_param += "}customer_id=" + customer_id + " &customer_email=" + customer_email;
      var checkout_url =
        "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
        myshopify_domain +
        "&cart_token=" +
        token +
        "&" +
        ga_linker +
        "&" +
        customer_param;
    } else {
      var checkout_url = "/checkout";
    }
    $("[data-cart-button]").click(function (e) {
      e.preventDefault();
      findSubscription = false;
      for (var j = 0; j < cart.items.length; j++) {
        if (cart.items[j].properties && cart.items[j].properties.subscription_id) {
          findSubscription = true;
        }
      }
      if (!findSubscription) {
        var checkout_url = "/checkout";
      } else {
        try {
          // Cross-domain tracking with Google Analytics
          var ga_linker = ga.getAll()[0].get("linkerParam");
        } catch (e) {
          // 'ga' is not available
          // console.log('GA Failed');
          var ga_linker = "";
        }

        var token = reChargeGetCookie("cart");
        var myshopify_domain = "synergicnutrition.myshopify.com";
        // Customer email address for use in the Checkout URL
        var customer_param = "";
        var customer_id = $("[data-customer]").attr("[data-customer-id]");
        var customer_email = $("[data-customer]").attr("[data-customer-mail]");
        if (customer_id && customer_email)
          customer_param += "}customer_id=" + customer_id + " &customer_email=" + customer_email;
        var checkout_url =
          "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
          myshopify_domain +
          "&cart_token=" +
          token +
          "&" +
          ga_linker +
          "&" +
          customer_param;
      }
      var value2 = parseInt($(settings.rewardBar2).data("free-shipping-bar2-2"));
      var cart_total2 = getPrice(cart.total_price, cart);
      var total = parseInt(cart_total2.substring(0, cart_total2.length - 1));
      var freeItem = parseInt($(settings.freeItemId).data("cart-free"));
      console.log(freeItem);
      console.log(value2);
      console.log(total);
      if (total >= value2) {
        var formData = {
          items: [
            {
              id: freeItem,
              quantity: 1
            }
          ]
        };
        let cart_freeItem = true;
        let cart_items = Object.entries(cart.items);
        cart_items.forEach((element) => {
          if (element[1].discounted_price == 0) {
            cart_freeItem = false;
            console.log(element[1].title);
          }
        });

        if (cart_freeItem) {
          let resp = jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            dataType: "json",
            success: function (e) {
              console.log("2 called");
              cart.items = [...e.items, ...cart.items];
              constructCart(cart, true);
            },
            error: function (err) {
              console.log("Erreur: ", err);
            }
          });
        }
      }
      $("[data-cart-button]").prop("disabled", "disabled");
      console.log("Checkout url " + checkout_url);
      console.log(cart.items);
      console.log("href: ", checkout_url);
      window.location.href = checkout_url;
    });

    if (open) openCart();

    $(settings.cartLoading).hide();
    //updateFreeShipping(getPrice(cart.total_price, cart));
    //updateFreeShipping2(getPrice(cart.total_price, cart));
    updateFreeShipping3(getPrice(cart.total_price, cart));
    console.log(cart.total_price);
    console.log(cart);
    console.log(getPrice(cart.total_price, cart));
  }

  function reChargeGetCookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
  }

  function getProductMetafields(handle) {
    const query = `query ProductMetafields($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        tags
        metafields(first: 100) {
          edges {
            node {
              namespace
              key
              value
            }
          }
        }
        variants(first: 100) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }`;

    const params = {
      query: query,
      variables: {
        handle: handle
      }
    };

    const optionsQuery = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": "dae5b64ac2c024d09b6642b0477e64e4"
      },
      body: JSON.stringify(params)
    };

    return fetch(`https://synergicnutrition.myshopify.com/api/graphql`, optionsQuery).then((res) => res.json());
  }

  function updateCartItems(items) {
    var tempFn = doT.template(document.getElementById("cart-items").innerHTML);
    var resultText = tempFn({ items: items });
    document.getElementById("cart-items__container").innerHTML = resultText;
  }

  function openCart() {
    if ($("body").hasClass("template-cart")) return;
    $("html").css("overflow", "hidden");
    $(settings.cartBackground).show();
    $(settings.cartSelector).addClass(settings.openCartClass);
    $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
    $(settings.headerSelector).addClass(settings.headerNotLight);
    $(settings.bodySelector).addClass(settings.nonScrollClass);
    setTimeout(function () {
      var cartHeaderHeight = document.querySelector(".cart-header").offsetHeight;
      var freeShippingHeight = document.querySelector(".free-shipping__container").offsetHeight;
      var relatedProductHeight = document.querySelector(".cart-addition").offsetHeight;
      var cartFooterHeight = document.querySelector(".cart-footer__content").offsetHeight;
      var windowHeight = window.innerHeight;
      var cartHeight = windowHeight - cartHeaderHeight - freeShippingHeight - relatedProductHeight - cartFooterHeight;
      $("#cart-items__result").css("max-height", cartHeight + "px");
    }, 1000);
  }

  function closeCart() {
    $("html").css("overflow", "auto");
    $(settings.cartSelector).removeClass(settings.openCartClass);
    $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
    $(settings.bodySelector).removeClass(settings.nonScrollClass);
    $(settings.cartBackground).hide();
    if ($("body").hasClass("template-cart")) window.location.href = "/";
  }

  function toggleCart() {
    if ($(settings.cartSelector).hasClass(settings.openCartClass)) closeCart();
    else openCart();
  }

  function addRechargeProduct($this, qty) {
    var discountVariantId = $this.data("cart-discount-variant-id");
    var subscription_id = $this.data("cart-subscription-id");
    var shippingIntervalFrequency = $this.data("shipping-interval-frequency");
    var shippingIntervalUnitType = $this.data("shipping-interval-unit-type");
    var key = $this.data("cart-item-key");
    if (qty == undefined) qty = 1;

    $(settings.cartLoading).show();
    var data = {
      id: discountVariantId,
      quantity: qty,
      properties: {
        subscription_id: subscription_id,
        shipping_interval_frequency: shippingIntervalFrequency,
        shipping_interval_unit_type: shippingIntervalUnitType
      }
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      async: true,
      data: data,
      dataType: "json",
      success: function () {
        jQuery.post("/cart/update.js", "updates[" + key + "]=" + 0).done(function () {
          $(document).trigger("cart.requestDone");
        });
      }
    });
  }

  return cart;
})();

var cart = new theme.cart();

theme.video = new (function () {
  var settings = {};
  var videosId = [];

  function video(videoSettings) {
    var defaultSettings = {
      video: "[data-video]",
      videoImage: "[data-video-image]",
      videoTextImage: "[data-video-text-image]",
      videoId: "[data-video-id]",
      videoTexts: "[data-video-texts]"
    };

    settings = $.extend({}, defaultSettings, videoSettings);

    $("[data-video-text-close]").on("click", function () {
      $("[data-video-text-content]").empty();
      $("[data-video-text-container]").hide();
    });

    $(settings.videoImage).on("click", function () {
      var $this = $(this);
      var container = $this.parent(settings.video);
      var video = $(container).find(settings.videoId);
      if ($(this).data("video-image") != "") {
        var sectionId = $(this).data("video-image");
        $("#video-text-" + sectionId)
          .clone()
          .appendTo(".video-text__content-video");
        $("[data-video-text-container]").show();
      } else {
        var texts = $(container).find(settings.videoTexts);
        $this.hide();
        texts.hide();
      }

      if (video.length > 0) {
        var id = $(video).data("video-id");

        document.getElementById(id).play();

        if (!videosId.includes(id)) {
          videosId.push(id);

          document.getElementById(id).addEventListener("play", function () {
            $this.hide();
            texts.hide();
          });

          document.getElementById(id).addEventListener("pause", function () {
            $this.show();
            texts.show();
          });

          document.getElementById(id).addEventListener("ended", function () {
            $this.show();
            texts.show();
          });
        }
      } else {
        var test = $(".article-video__youtube")[0];
        $(test).attr("src", $(test).data("autoplay-src"));
      }
    });
  }

  return video;
})();

var video = new theme.video();

theme.apport = new (function () {
  var settings = {};

  function apport(apportSettings) {
    var defaultSettings = {
      apportTabs: "[data-apport-tabs]",
      apportTabTitle: "[data-apport-tab-title]",
      apportTab: "[data-apport-tab]"
    };

    settings = $.extend({}, defaultSettings, apportSettings);

    $(settings.apportTabTitle).on("click", function () {
      var $this = $(this);
      toggleTabs($this);
    });
  }

  function toggleTabs($this) {
    var tabsContainer = $this.closest(settings.apportTabs);
    var tabSelected = $this.data("apport-tab-title");

    var titles = tabsContainer.find(settings.apportTabTitle);
    titles.each(function () {
      if ($(this).data("apport-tab-title") != tabSelected) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });

    var tabs = tabsContainer.find(settings.apportTab);
    tabs.each(function () {
      if ($(this).data("apport-tab") != tabSelected) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });
  }

  return apport;
})();

var apport = new theme.apport();

theme.productZerance = new (function () {
  var settings = {};

  function productZerance(productZeranceSettings) {
    var defaultSettings = {
      productPage: "[data-product-page]",
      productNavigationContainer: "[data-product-navigation-container]",
      productNavigation: "[data-product-navigation]",
      productNavigationTab: "[data-product-navigation-tab]",
      productNavigationLink: "[data-product-navigation-link]",
      productFlickity: "[data-product-flickity]",
      productMiniatures: "[data-product-miniatures]",
      productMiniature: "[data-product-miniature]",
      productTabMobile: "[data-product-tab-mobile]",
      productFlickityAlt: "[data-product-flickity-alt]",
      productQuantity: "[data-product-quantity]",
      currentIndex: 0,
      productVariantTitle: "[data-product-variant-title]",
      productQuantityButton: "[data-product-quantity-btn]",
      // NAVIGATION MOBILE
      productNavigationGlobaleMobile: "[data-product-navigation-globale-mobile]",
      productNavigationDetailsMobile: "[data-product-navigation-details-mobile]",
      // ADD TO CART
      formAddSubscription: "[data-form-add-subscription]",
      subscriptionOption: "[data-subscription-option]",
      // SELECT VARIANTS
      productSwatchSelected: "[data-product-swatch-selected]",
      productSwatchOptionsContainer: "[data-product-swatch-options-container]",
      productFlavors: "[data-product-flavors]",
      productSwatchSku: "[data-product-swatch0-sku]",
      productSwatchVariantTitle: "[data-product-swatch-variant-title]",
      productSwatchSelectedTitle: "[data-product-swatch-selected-title]",
      productSwatchTitle: "[data-product-swatch-title]"
    };

    settings = $.extend({}, defaultSettings, productZeranceSettings);

    $(settings.productNavigationLink).on("click", function () {
      var $this = $(this);
      toggleTabs($this);
    });

    $(settings.productNavigationGlobaleMobile).on("click", function () {
      $(this).addClass("active");
      $(settings.productNavigationDetailsMobile).removeClass("active");
      $("html, body").animate({ scrollTop: $("body").position().top }, "slow");
    });

    $(document).ready(function () {
      $(settings.productNavigationDetailsMobile).on("click", function () {
        $(this).addClass("active");
        $(settings.productNavigationGlobaleMobile).removeClass("active");
        $("html, body").animate({ scrollTop: menuPosition.top }, "slow");
      });
      updatePricePerDoses("oneshot");
    });

    $(settings.productTabMobile).on("click", function () {
      var data = $(this).data("product-tab-mobile");

      if ($('[data-product-tab-content-mobile="' + data + '"]').is(":visible")) {
        $('[data-product-tab-content-mobile="' + data + '"]').slideToggle();
      } else {
        $("[data-product-tab-content-mobile]").each(function () {
          if ($(this).is(":visible")) {
            $(this).slideToggle();
          }
        });
        $('[data-product-tab-content-mobile="' + data + '"]').slideToggle();
      }
      $("html, body").animate(
        {
          scrollTop: $(".product-navigation-mobile__tabs").position().top + 1000
        },
        "slow"
      );
    });

    $(document).ready(function () {
      $("[data-option-index]").each(function () {
        var flavorsNbr = $(this).find(".product-color").length - 2;
        $(this).find(settings.productFlavors).text(flavorsNbr);
        $(settings.productQuantity).val(1);
        if (flavorsNbr == 0) {
          $(this).find(".product-color__same-options, .product__swatch-arrow").addClass("hide");
        }
      });
      if ($(settings.productFlickity).length > 0) {
        initFlickity();
        setTimeout(function () {
          $carousel = $(settings.productFlickity);

          if ($("input[name='option-0']").length > 0) {
            showMatchingImages($carousel);
          } else {
            $(".product__images-container").show();
            $carousel.flickity("resize");
          }

          var $cellButtonGroup = $(settings.productMiniatures);
          var $cellButtons = $cellButtonGroup.find(settings.productMiniature);

          // update selected cellButtons
          $carousel.on("select.flickity", function () {
            $cellButtons.filter(".is-selected").removeClass("is-selected");
            $cellButtons.eq(settings.currentIndex).addClass("is-selected");
          });

          // select cell on button click
          $cellButtonGroup.on("click", settings.productMiniature, function () {
            settings.currentIndex = $(this).index();
            $carousel.flickity("select", settings.currentIndex);
          });
        }, 500);
      }

      if ($("input[name=product_type]").length > 0) formSubscriptionValue();

      if (settings.productNavigationTab.length > 0 && $(window).width() < 800) {
        $("[data-product-navigation-tab='ingredients']").appendTo("[data-product-tab-ingredients]");
        $("[data-product-navigation-tab='how']").appendTo("[data-product-tab-how]");
        $("[data-product-navigation-tab='nutriments']").appendTo("[data-product-tab-apports]");
        $("[data-product-navigation-reviews]").appendTo("[data-product-tab-reviews]");
        $("[data-product-navigation-tab='faq']").appendTo("[data-product-tab-faq]");
      }

      $(settings.productSwatchSelected).on("click", function () {
        var options = $(this).next(settings.productSwatchOptionsContainer);
        if (options.hasClass("active")) {
          $(this).removeClass("active");
          options.removeClass("active");
        } else {
          $(settings.productSwatchSelected).filter(".active").removeClass("active");
          $(settings.productSwatchSelected).each(function () {
            var opts = $(this).next(settings.productSwatchOptionsContainer);
            $(opts).removeClass("active");
          });
          $(this).addClass("active");
          options.addClass("active");
        }
      });

      $(document).ready(function () {
        if ($("[data-pack-discovery-title]").length > 0) {
          $(".breadcrumb span").last().text($("[data-pack-discovery-title]").text());
        }
      });

      $("body").on("change", "input[name='option-0']", function () {
        var productTitle = $("[data-product-flickity-title]").attr("data-product-flickity-title").toLowerCase();
        var container = $(this).closest("[data-option-index]");
        var option = container.find(".header");
        option = $(option).text();

        if (option.indexOf("flavor") !== -1 && $("[data-product-variant-title]").length > 0) {
          $(".breadcrumb span").last().text($("[data-product-variant-title]").text());
        } else if ($("[data-pack-discovery-title]").length > 0) {
          $(".breadcrumb span").last().text($("[data-pack-discovery-title]").text());
        }

        if (!productTitle.includes("pack") && $(this).val() == "Natural")
          $("[data-product-swatch-options-container]").eq(1).addClass("hide");
        else $("[data-product-swatch-options-container]").eq(1).removeClass("hide");

        if (container.attr("data-option-index") == 0) {
          $carousel = $(settings.productFlickity);
          $carousel.flickity("destroy");
          initFlickity();
          showMatchingImages($carousel);
        }

        var container = $(this).closest(settings.productSwatchOptionsContainer);
        var currentSelect = container.prev(settings.productSwatchSelected);
        container.removeClass("active");
        currentSelect.removeClass("active");
      });

      $("body").on("change", "input[name='option-1']", function () {
        var container = $(this).closest(settings.productSwatchOptionsContainer);
        var currentSelect = container.prev(settings.productSwatchSelected);
        container.removeClass("active");
        currentSelect.removeClass("active");
        var productType = $("input[name=product_type]:checked").val();
        updatePricePerDoses(productType);
      });

      // CAS PARTICULIER POUR NATURAL
      $('[data-product-swatch-variant="32138013180017"]').on("click", function () {
        $("[data-product-swatch-variant='32138012819569']").click();
        $('[data-product-swatch-variant="32138012721265"]').click();
      });

      $("[data-product-swatch-variant").on("click", function () {
        updateImagesWithGrammes();
      });
    });

    $("input[type=radio][name=product_type]").change(function () {
      formSubscriptionValue();
      var productType = $("input[name=product_type]:checked").val();

      if (productType == "unique") {
        $(".product__reduction").css("opacity", "0.3");
        $(".advantages__infos").show();
        $(".advantages__link").hide();
      } else {
        $(".product__reduction").css("opacity", "1");
        $(".advantages__infos").hide();
        $(".advantages__link").show();
      }

      updatePricePerDoses(productType);
    });

    $(settings.productSwatchSku).on("click", function () {
      if ($("#product__trustpilot").length == 0) return;

      var sku = $(this).data("product-swatch0-sku");
      // console.log(sku)
      var splitSku = sku.split("-");
      var skus =
        splitSku[0] +
        "-" +
        splitSku[1] +
        "-450G," +
        splitSku[0] +
        "-" +
        splitSku[1] +
        "-900G," +
        splitSku[0] +
        "-" +
        splitSku[1] +
        "-18KG";
      $("#product__trustpilot").attr("data-sku", skus);
      $("#product__trustpilot").load(" #product__trustpilot > *", function () {
        const trustbox = document.getElementById("product__trustpilot");
        window.Trustpilot.loadFromElement(trustbox);
      });
    });

    $(settings.productQuantityButton).on("click", function () {
      console.log("hello clicked");
      var quantity = $(this).attr("data-product-quantity-btn");
      var oldQuantity = $(settings.productQuantity).val();
      if (quantity > 0) {
        $(settings.productQuantity).val(quantity);
        var newBtnMinusVal = parseInt($(settings.productQuantity).val()) - 1;
        var newBtnPlusVal = parseInt($(settings.productQuantity).val()) + 1;

        $(settings.productQuantityButton).each(function (index) {
          if (index == 0) {
            $(this).attr("data-product-quantity-btn", newBtnMinusVal);
            console.log(newBtnMinusVal);
            if (newBtnMinusVal == 0) {
              $(this).addClass("not-available");
            } else {
              $(this).removeClass("not-available");
            }
          } else if (index == 1) {
            $(this).attr("data-product-quantity-btn", newBtnPlusVal);
          }
        });
        updatePrices(quantity, oldQuantity);
      }
    });

    // ADD TO CART
    $(".bundle_qty_plus").on("submit", function (event) {
      event.preventDefault();
      var variantId = $(this).attr("data-product-add-to-cart");
      var qty = $(settings.productQuantity);
      qty = $(qty).val();
      addToCartSimple(variantId, qty);
    });
    $("[data-form-add-subscription]").on("submit", function (event) {
      event.preventDefault();
      if ($(this).attr("data-form-add-subscription") == "false") {
        var variantId = $(this).attr("data-product-add-to-cart");
        var qty = $(settings.productQuantity);

        qty = $(qty).val();
        addToCartSimple(variantId, qty);
      } else {
        $("[data-product-add-to-cart]").each(function () {
          $(this).prop("disabled", true);
        });

        if ($("input[name=product_type]:checked").val() == "recharge") {
          addToCartRecharge();
        } else {
          $(settings.formAddSubscription).attr("form-add-subscription", "false");
          $("[data-add-to-cart]").prop("disabled", false);
        }
      }
    });

    $("[data-product-add-to-cart-button]").on("click", function () {
      $("[data-form-add-subscription]").submit();
    });
  }

  function updateImagesWithGrammes() {
    setTimeout(function () {
      var grammes = $('[data-product-swatch-selected-title="option2"]').text();
      var grammesArray = ["450g", "900g"];
      if (grammesArray.includes(grammes)) {
        $(".product__miniature").each(function () {
          var src = $(this).attr("src");
          if ($(this).is(":visible") && src.indexOf(grammes) >= 0) {
            console.log($(this).attr("src"));
            console.log($(this).parent());
            var parent = $(this).parent();
            $(parent).click();
            return false;
          }
        });
      }
    }, 100);
  }

  function updatePricePerDoses(productType) {
    $("[data-product-price-dose]").each(function () {
      var container = $(this).closest(".swatch-element");
      var currentInput = container.find("input[name='option-1']");
      var priceContainer = $(this).find(".money");

      var priceDose = $(this).attr("data-product-price-dose");
      var priceDose = parseInt(priceDose) / 100;

      var normalPriceDose = priceDose;
      var rechargePriceDose = priceDose * 0.85;

      if (productType == "recharge") {
        priceDose = priceDose * 0.85;
      }

      if (currentInput.is(":checked")) {
        $("[data-product-format-dose]").text(priceDose.toFixed(2).replace(".", ",") + "€/dose");
        if (window.location.href.indexOf("barres-proteinees") > -1) {
          var normalPricedDoseText = normalPriceDose.toFixed(2).replace(".", ",") + "€/barre";
        } else {
          var normalPricedDoseText = normalPriceDose.toFixed(2).replace(".", ",") + "€/dose";
        }

        if (normalPricedDoseText.indexOf("NaN") !== -1) {
          $("[data-oneshot-price-per-dose]").hide();
        } else {
          $("[data-oneshot-price-per-dose]").text(normalPricedDoseText);
          $("[data-oneshot-price-per-dose]").show();
        }

        if (window.location.href.indexOf("barres-proteinees") > -1) {
          var rechargePricedDoseText = rechargePriceDose.toFixed(2).replace(".", ",") + "€/barre";
        } else {
          var rechargePricedDoseText = rechargePriceDose.toFixed(2).replace(".", ",") + "€/dose";
        }
        if (rechargePricedDoseText.indexOf("NaN") !== -1) {
          $("[data-recharge-price-per-dose]").hide();
        } else {
          $("[data-recharge-price-per-dose]").text(rechargePricedDoseText);
          $("[data-recharge-price-per-dose]").show();
        }

        // if($('[data-avantages]').hasClass('product__avantages--off')){
        //     $('[data-avantages]').removeClass('product__avantages--off')
        //     $('[data-avantages]').addClass('product__avantages--on')
        // }else{
        //     $('[data-avantages]').addClass('product__avantages--off')
        //     $('[data-avantages]').removeClass('product__avantages--on')
        // }
      }
      priceContainer.text(priceDose.toFixed(2) + "€/dose");
    });
  }

  $("#product_recharge, #product_unique").on("change", function () {
    if ($("#product_recharge").is(":checked")) {
      $("[data-avantages]").removeClass("product__avantages--off");
      $("[data-avantages]").addClass("product__avantages--on");
    } else {
      $("[data-avantages]").addClass("product__avantages--off");
      $("[data-avantages]").removeClass("product__avantages--on");
    }
  });

  function updatePrices(quantity, oldQuantity) {
    try {
      var currentPriceContainer = $("[data-product-price]").find(".money");
      var priceContainer = currentPriceContainer[0];
      var price = priceContainer.innerHTML;
      price = price.replace(",", ".").replace("€", "");
      price = parseFloat(price);

      var $currentVariant = $("[data-product-select] option:selected");
      var currentVariantDiscountPrice = $currentVariant.data("discount-variant-price");

      price = (price / oldQuantity) * quantity;
      currentVariantDiscountPrice = currentVariantDiscountPrice * quantity;

      price = price.toFixed(2) + "€";
      currentPriceContainer.text(price.replace(".", ",").replace(",00", ""));
      if (currentVariantDiscountPrice != "" || currentVariantDiscountPrice != undefined) {
        currentVariantDiscountPrice = currentVariantDiscountPrice.toFixed(2) + "€";
        $("[data-product-price-recharge]").text(currentVariantDiscountPrice.replace(".", ",").replace(",00", ""));
      }
      if ($("[data-product-price2]").length > 0) {
        var currentPriceContainer2 = $("[data-product-price2]").find(".money");
        var priceContainer2 = currentPriceContainer2[0];
        var price2 = priceContainer2.innerHTML;
        price2 = price2.replace(",", ".").replace("€", "");
        price2 = parseFloat(price2);
        price2 = (price2 / oldQuantity) * quantity;
        price2 = price2.toFixed(2) + "€";
        currentPriceContainer2.text(price2.replace(".", ",").replace(",00", ""));
      }
    } catch (err) {}
  }

  function showMatchingImages($carousel) {
    if ($("input[name='option-0']").is(":checked")) {
      var currentVariant = $("input[name='option-0']:checked");
    } else {
      var currentVariant = $("input[name='option-0']").first();
    }

    var container = $(currentVariant).closest("[data-value]");
    var label = $(container).find("label");
    var currentVariantTitle = $(label).attr("data-product-swatch-variant-title").toLowerCase();
    var firstImageAlt = $($("[data-product-miniatures] " + settings.productFlickityAlt))[0];
    var firstImageAvailable = true;

    $("[data-product-miniatures] " + settings.productFlickityAlt).each(function (index) {
      var currentDot = $("[data-product-flickity] .dot")[index];
      var currentImage = $("[data-product-flickity] " + settings.productFlickityAlt)[index];
      var variantAlt = $(this).attr("data-product-flickity-alt").toLowerCase();
      var productTitle = $(this).attr("data-product-flickity-title").toLowerCase();

      if (currentVariantTitle.includes(variantAlt) || variantAlt == productTitle) {
        if (firstImageAvailable) {
          $(currentDot).addClass("is-selected");
          $carousel.flickity("select", index);
          firstImageAvailable = false;
        }
        $(this).removeClass("hide");
        $(currentDot).removeClass("hide");
        $(currentImage).removeClass("hide");
      } else {
        $(this).remove();
        $(this).addClass("hide");
        $(currentDot).addClass("hide");
        $(currentImage).addClass("hide");
      }
    });
    initFlickity();

    if ($("[data-product-miniatures] " + settings.productFlickityAlt).length > 0) {
      if (!currentVariantTitle.includes($(firstImageAlt).attr("data-product-flickity-alt").toLowerCase())) {
        var firstDot = $("[data-product-flickity] .dot")[0];
        $(firstDot).removeClass("is-selected");
        $(firstDot).addClass("hide");
      }
      $(".product__images-container").show();
      $carousel.flickity("resize");
      updateImagesWithGrammes();
    }
  }

  function toggleTabs($this) {
    var height = $(settings.productPage).height() - 70;
    $("html, body").animate(
      {
        scrollTop: height
      },
      800
    );

    var tabsContainer = $this.closest(settings.productNavigationContainer);
    var tabSelected = $this.data("product-navigation-link");

    var tabs = tabsContainer.find(settings.productNavigationTab);
    tabs.each(function () {
      if ($(this).data("product-navigation-tab") != tabSelected) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });

    var links = tabsContainer.find(settings.productNavigationLink);
    links.each(function () {
      if ($(this).data() != $this.data()) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });
  }

  function initFlickity() {
    // init Flickity
    let $carou;
    if ($(window).width() < 800) {
      $carou = $(settings.productFlickity).flickity({
        // prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: false,
        // draggable: false,
        selectedAttraction: 0.2,
        friction: 0.6,
        adaptiveHeight: false,
        arrowShape: {
          x0: 25,
          x1: 50,
          y1: 35,
          x2: 65,
          y2: 35,
          x3: 40
        }
      });
    } else {
      $carou = $(settings.productFlickity).flickity({
        // prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: false,
        // draggable: false,
        adaptiveHeight: true,
        selectedAttraction: 0.2,
        friction: 0.6,
        arrowShape: {
          x0: 25,
          x1: 50,
          y1: 35,
          x2: 65,
          y2: 35,
          x3: 40
        }
      });
    }
    const elements = $("[data-product-flickity-alt].to_del_cell");
    console.log(elements);
    $carou.flickity("remove", elements);
  }

  function addItem(form_id) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: $("#" + form_id).serialize(),
      success: addToCartOk,
      error: addToCartFail
    });
  }

  function formSubscriptionValue() {
    if ($("input[name=product_type]:checked").val() == "recharge") {
      $(settings.formAddSubscription).attr("data-form-add-subscription", "true");
      $(settings.subscriptionOption).show();
    } else {
      $(settings.formAddSubscription).attr("data-form-add-subscription", "false");
      $(settings.subscriptionOption).hide();
    }
  }

  // hide non existing options

  $('[data-option-index="0"]')
    .find("[data-product-swatch-options-container]")
    .on("rightnow change", function () {
      var option1 = "";
      var option2 = "";
      var option3 = "";
      var options = [];
      var variants = [];

      $(this)
        .find(".swatch-element")
        .each(function () {
          option1 = $(this).data("value");
          $('[data-option-index="1"] [data-product-swatch-options-container]')
            .find(".swatch-element")
            .each(function () {
              option2 = $(this).data("value");

              if ($('[data-option-index="2"] [data-product-swatch-options-container]').length > 0) {
                option3 = $('[data-option-index="2"] [data-product-swatch-options-container]')
                  .find(".swatch-element")
                  .data("value");
                options.push(option1 + " / " + option2 + " / " + option3);
              } else {
                options.push(option1 + " / " + option2);
              }
            });
        });

      //console.log('options: ' + options);

      $("[data-product-select]")
        .find("option")
        .each(function () {
          var variant = $(this).text().trim();
          variants.push(variant);
        });
      //console.log('variants: ' + variants);
      var falseProduct = [];
      for (let i = 0; i < options.length; i++) {
        var allOptions = options[i];
        //console.log('allOptions: ' + allOptions);

        if (variants.includes(allOptions)) {
        } else {
          falseProduct.push(allOptions);
        }
      }
      //console.log('falseProduct: ' + falseProduct);
      var answer = false;
      var answer2 = false;
      for (let i = 0; i < falseProduct.length; i++) {
        var falseProductOptions = falseProduct[i].split(" / ");
        if (falseProductOptions[0].indexOf($('[data-product-swatch-selected-title="option1"]').text().trim()) > -1) {
          if ($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]) {
            answer = true;
            console.log($('[data-product-swatch-selected-title="option1"]').text().trim());
            console.log($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]);
            //$('[data-option-index="1"]').find('label:contains("' + falseProductOptions[1] + '")').addClass('hide');
          } else {
            answer2 = true;
            console.log($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]);
            $('[data-option-index="1"]').find("label").removeClass("hide");
            console.log($('[data-product-swatch-selected-title="option1"]').text().trim());
          }
        } else {
          //console.log($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]);
          //$('[data-option-index="1"]').find('label').removeClass('hide');
          //console.log($('[data-product-swatch-selected-title="option1"]').text().trim());
        }
      }

      if (answer == false && answer2 == false) {
        $('[data-option-index="1"]').find("label").removeClass("hide");
      } else {
        $('[data-option-index="1"]')
          .find('label:contains("' + falseProductOptions[1] + '")')
          .addClass("hide");
      }
    })
    .triggerHandler("rightnow");

  return productZerance;
})();

var productZerance = new theme.productZerance();

theme.ingredients = new (function () {
  var settings = {};

  function ingredients(ingredientsSettings) {
    var defaultSettings = {
      productNavigationLink: "[data-product-navigation-link]",
      ingredientsFlickity: "[data-ingredients-flickity]",
      productNavigationTabTitleMobile: ".product-navigation-mobile__tab-title",
      flickityInit: false,
      adaptiveHeight: false,
      draggable: false
    };

    settings = $.extend({}, defaultSettings, ingredientsSettings);

    if ($(window).width() < 800) {
      settings.adaptiveHeight = true;
      settings.draggable = true;
    }

    $(document).ready(function () {
      $("body").on("click", settings.productNavigationTabTitleMobile, function () {
        var data = $(this).data();
        if (!settings.flickityInit && data.productTabMobile == 1) {
          initFlickity();
          settings.flickityInit = true;
        }
      });
    });

    $(settings.productNavigationLink).on("click", function () {
      if (!settings.flickityInit) {
        if ($(this).data("product-navigation-link") == "ingredients") {
          initFlickity();
          settings.flickityInit = true;
        }
      }
    });
  }

  function initFlickity() {
    var $carousel = $(settings.ingredientsFlickity).flickity({
      groupCells: true,
      draggable: settings.draggable,
      groupCells: 1,
      contain: true,
      pageDots: true,
      adaptiveHeight: settings.adaptiveHeight,
      prevNextButtons: true,
      arrowShape: { x0: 20, x1: 55, y1: 35, x2: 65, y2: 20, x3: 45 }
    });

    // Flickity instance
    var flkty = $carousel.data("ingredients-flickity");
    var $cellsContainer = $(".carousel-main");
    var $cells = $cellsContainer.find(".ingredients__current-block");

    $carousel.on("change.flickity", function (event, index) {
      $cells.filter(".is-selected").removeClass("is-selected");
      $cells.eq(index).addClass("is-selected");
      $carousel.flickity("select", index);
    });

    $("[data-ingredients-button]").on("click", function (event) {
      event.preventDefault();
      var index = $(this).data("ingredients-button");
      $cells.filter(".is-selected").removeClass("is-selected");
      $cells.eq(index).addClass("is-selected");
      $carousel.flickity("select", index);
    });
  }

  return ingredients;
})();

var ingredients = new theme.ingredients();

theme.nutriments = new (function () {
  var settings = {};
  var nutrimentssId = [];

  function nutriments(nutrimentsSettings) {
    var defaultSettings = {
      nutrimentsTabTitle1: "[data-nutriments-tab-title1]",
      nutrimentsTabTitle2: "[data-nutriments-tab-title2]",
      nutrimentsTab1: "[data-nutriments-tab1]",
      nutrimentsTab2: "[data-nutriments-tab2]"
    };

    settings = $.extend({}, defaultSettings, nutrimentsSettings);

    $(settings.nutrimentsTabTitle1).on("click", function () {
      $(settings.nutrimentsTabTitle2).removeClass("active");
      $(settings.nutrimentsTabTitle1).addClass("active");
      $(settings.nutrimentsTab2).hide();
      $(settings.nutrimentsTab1).show();
    });

    $(settings.nutrimentsTabTitle2).on("click", function () {
      $(settings.nutrimentsTabTitle1).removeClass("active");
      $(settings.nutrimentsTabTitle2).addClass("active");
      $(settings.nutrimentsTab1).hide();
      $(settings.nutrimentsTab2).show();
    });
  }

  return nutriments;
})();

var nutriments = new theme.nutriments();

theme.menu = new (function () {
  var settings = {};

  function menu(menuSettings) {
    var defaultSettings = {
      menuHistory: "[data-menu-history]"
    };

    settings = $.extend({}, defaultSettings, menuSettings);

    $(document).on("click", 'a[href^="#"]', function (e) {
      if ($(this).data("charge-id")) return;

      var id = $(this).attr("href");
      var $id = $(id);

      if ($(settings.menuHistory).length > 0) {
        $(settings.menuHistory).filter(".active").removeClass("active");
      }

      $("a[href='" + id + "']").each(function () {
        $(this).addClass("active");
      });

      if ($id.length === 0) return;
      e.preventDefault();
      var pos = $id.offset().top;
      $("body, html").animate({ scrollTop: pos - 65 });
    });

    if ($(settings.menuHistory).length > 0) {
      if ($(window).width() > 800) {
        var height = $(window).height();
        $(window).scroll(function () {
          var scroll = $(window).scrollTop();
          if (height < scroll) {
            $(".menu-history").show();
          } else {
            $(".menu-history").hide();
          }
        });
      }
    }
  }

  return menu;
})();

var menu = new theme.menu();

theme.swatch = new (function () {
  var settings = {};

  function swatch(swatchSettings) {
    var defaultSettings = {};

    settings = $.extend({}, defaultSettings, swatchSettings);

    $(document).ready(function () {
      jQuery(function () {
        jQuery(".swatch :radio").change(function () {
          var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
          var optionValue = jQuery(this).val();
          jQuery(this)
            .closest("form")
            .find("[data-single-option-selector]")
            .eq(optionIndex)
            .val(optionValue)
            .trigger("change");
        });
      });
    });
  }

  return swatch;
})();

var swatch = new theme.swatch();
theme.quickView = new (function () {
  var settings = {
    // action selector
    openSelector: "[data-quick-view-open]",
    closeSelector: "[data-quick-view-close]",
    // content selector
    quickView: "[data-quick-view]",
    quickViewOverlay: "[data-quick-view-overlay]",
    quickViewContent: "[data-quick-view-content]",
    quickViewLoading: "[data-quick-view-loading]"
  };

  function quickView() {
    $(settings.openSelector).on("click", function () {
      var product_handle = $(this).data("product-handle");
      var product_variant_id = $(this).data("quick-view-open");
      $(settings.quickViewLoading).show();
      if (product_variant_id.length != null || product_variant_id.length != "") {
        open(product_handle, product_variant_id);
      } else {
        open(product_handle);
      }
    });

    $(settings.closeSelector).on("click", function () {
      close();
    });
  }

  function open(product_handle, swatch_id) {
    // init popup with info
    $.get("/products/" + product_handle + "?view=quick-view", function (data) {
      $(settings.quickViewContent).html(data);
      // hide non existing options

      $('[data-option-index="0"]')
        .find("[data-product-swatch-options-container]")
        .on("rightnow change", function () {
          var option1 = "";
          var option2 = "";
          var option3 = "";
          var options = [];
          var variants = [];

          $(this)
            .find(".swatch-element")
            .each(function () {
              option1 = $(this).data("value");
              $('[data-option-index="1"] [data-product-swatch-options-container]')
                .find(".swatch-element")
                .each(function () {
                  option2 = $(this).data("value");

                  if ($('[data-option-index="2"] [data-product-swatch-options-container]').length > 0) {
                    option3 = $('[data-option-index="2"] [data-product-swatch-options-container]')
                      .find(".swatch-element")
                      .data("value");
                    options.push(option1 + " / " + option2 + " / " + option3);
                  } else {
                    options.push(option1 + " / " + option2);
                  }
                });
            });

          $("[data-product-select]")
            .find("option")
            .each(function () {
              var variant = $(this).text().trim();
              variants.push(variant);
            });
          var falseProduct = [];
          for (let i = 0; i < options.length; i++) {
            var allOptions = options[i];

            if (variants.includes(allOptions)) {
            } else {
              falseProduct.push(allOptions);
            }
          }
          var answer = false;
          var answer2 = false;
          for (let i = 0; i < falseProduct.length; i++) {
            var falseProductOptions = falseProduct[i].split(" / ");
            if (
              falseProductOptions[0].indexOf($('[data-product-swatch-selected-title="option1"]').text().trim()) > -1
            ) {
              if ($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]) {
                answer = true;
                //$('[data-option-index="1"]').find('label:contains("' + falseProductOptions[1] + '")').addClass('hide');
              } else {
                answer2 = true;
                $('[data-option-index="1"]').find("label").removeClass("hide");
              }
            } else {
              //console.log($('[data-product-swatch-selected-title="option1"]').text() == falseProductOptions[0]);
              //$('[data-option-index="1"]').find('label').removeClass('hide');
              //console.log($('[data-product-swatch-selected-title="option1"]').text().trim());
            }
          }

          if (answer == false && answer2 == false) {
            $('[data-option-index="1"]').find("label").removeClass("hide");
          } else {
            $('[data-option-index="1"]')
              .find('label:contains("' + falseProductOptions[1] + '")')
              .addClass("hide");
          }
        })
        .triggerHandler("rightnow");
      var productContainer = $(settings.quickViewContent).find('[data-section-id="product"]');
      var customProduct = new theme.Product(productContainer);
      var swatch = new theme.swatch();
      var recharge = new theme.productZerance();
      if (swatch_id) {
        $(settings.quickViewContent).hide();
        setTimeout(function () {
          $(settings.quickViewLoading).hide();
          if (swatch_id == 32138013180017) {
            $("[data-product-swatch-variant='32138012819569']").click();
          }
          $(settings.quickViewContent)
            .find('[data-product-swatch-variant="' + swatch_id + '"]')
            .click();
          $(settings.quickViewContent).show();
          $(settings.quickViewContent).find("#BIS_trigger").remove();
        }, 300);
      }
    });

    // display popup
    $(settings.quickView).addClass("active");
    $(settings.quickViewOverlay).addClass("active");
  }

  function close() {
    $(settings.quickViewContent).html("");
    $(settings.quickView).removeClass("active");
    $(settings.quickViewOverlay).removeClass("active");
  }

  // notify me button on popup
  $(".collection__card").each(function () {
    var notifyButton = $(this).find(".BIS_trigger");
    var orderButton = $(this).find(".list-collection__link");

    orderButton.on("click", function () {
      setTimeout(function () {
        notifyButton.clone().appendTo(".quick-view").css("display", "block");
      }, 600);
    });
  });

  $("[data-quick-view-close]").on("click", function () {
    $(".quick-view").find(".BIS_trigger").remove();
  });

  return quickView;
})();

var quickView = new theme.quickView();

theme.collection = new (function () {
  var settings = {};

  function collection(collectionSettings) {
    var defaultSettings = {
      collectionContainer: "[data-collection-container]",
      collectionFiltersSelect: "[data-collection-filters-select]",
      collectionFiltersOptions: "[data-collection-filters-options]",
      collectionFilterLabel: "[data-collection-filter-label]",
      collectionFiltersSelect2: "[data-collection-filters-select-2]",
      collectionFiltersOptions2: "[data-collection-filters-options-2]",
      collectionFilterLabel2: "[data-collection-filter-label-2]",
      bannerCollectionBackground: ".banner-collection__background"
    };

    settings = $.extend({}, defaultSettings, collectionSettings);

    $(settings.collectionFiltersSelect).on("click", function () {
      var select = $(this).find("span");
      var selectName = select.data("select-name");
      select.text(selectName);

      if ($(settings.collectionFiltersOptions2).is(":visible")) {
        $(settings.collectionFiltersOptions2).slideToggle();
      }
      $(settings.collectionFiltersOptions).slideToggle();
    });

    $(settings.collectionFiltersSelect2).on("click", function () {
      var select = $(this).find("span");
      var selectName = select.data("select-name");
      select.text(selectName);

      if ($(settings.collectionFiltersOptions).is(":visible")) {
        $(settings.collectionFiltersOptions).slideToggle();
      }
      $(settings.collectionFiltersOptions2).slideToggle();
    });

    $(settings.collectionFilterLabel).on("click", function () {
      var img = $(this).data("collection-filter-label");
      $(settings.bannerCollectionBackground).each(function () {
        $(this).attr("src", img);
        $(this).removeAttr("srcset");
      });

      var select = $(settings.collectionFiltersSelect).find("span");
      var filter = $(this).find("span");
      select.text(filter.text());

      $(settings.collectionFiltersOptions).slideToggle();
    });
    $(settings.collectionFilterLabel2).on("click", function () {
      var select = $(settings.collectionFiltersSelect2).find("span");
      var filter = $(this).find("span");
      select.text(filter.text());

      $(settings.collectionFiltersOptions2).slideToggle();
    });

    $('input[name="collection_filters"').on("change", function () {
      var value = $('input[name="collection_filters"]:checked').val();
      updateFilter(value);
    });
    $('input[name="collection_filters2"').on("change", function () {
      var value = $('input[name="collection_filters2"]:checked').val();
      updateFilter2(value);
    });
  }

  function updateFilter(value) {
    if (value == "fitness") {
      $(settings.collectionContainer).removeClass("filter__sante");
      $(settings.collectionContainer).addClass("filter__fitness");
    } else if (value == "sante") {
      $(settings.collectionContainer).removeClass("filter__fitness");
      $(settings.collectionContainer).addClass("filter__sante");
    } else {
      $(settings.collectionContainer).removeClass("filter__sante");
      $(settings.collectionContainer).removeClass("filter__fitness");
    }
  }

  function updateFilter2(value) {
    if (value == "matin") {
      $(settings.collectionContainer).addClass("filter__matin");
      $(settings.collectionContainer).removeClass("filter__midi");
      $(settings.collectionContainer).removeClass("filter__soir");
    } else if (value == "midi") {
      $(settings.collectionContainer).addClass("filter__midi");
      $(settings.collectionContainer).removeClass("filter__matin");
      $(settings.collectionContainer).removeClass("filter__soir");
    } else if (value == "soir") {
      $(settings.collectionContainer).addClass("filter__soir");
      $(settings.collectionContainer).removeClass("filter__matin");
      $(settings.collectionContainer).removeClass("filter__midi");
    } else {
      $(settings.collectionContainer).removeClass("filter__matin");
      $(settings.collectionContainer).removeClass("filter__midi");
      $(settings.collectionContainer).removeClass("filter__soir");
    }
  }

  return collection;
})();

var collection = new theme.collection();

theme.faq = new (function () {
  var settings = {};

  function faq(faqSettings) {
    var defaultSettings = {
      faqSelectOption: "[data-faq-selected-option]",
      faqContainer: "[data-faq-container]",
      faqTitle: "[data-faq-title]",
      faqQuestionBlock: "[data-faq-question-block]",
      collectionFiltersOptions: "[data-collection-filters-options]",
      faqVideos: "[data-faq-videos]",
      faqVideo: "[data-faq-video]",
      oldHandle: ""
    };

    settings = $.extend({}, defaultSettings, faqSettings);

    $(settings.faqSelectOption).on("click", function () {
      var handle = $(this).data("faq-selected-option");

      $(settings.faqSelectOption).each(function () {
        $(this).removeClass("color--green");
      });
      $(this).addClass("color--green");

      $(settings.faqContainer).hide();

      if (settings.oldHandle != "" || settings.oldHandle != undefined) {
        $('[data-faq-title="' + settings.oldHandle + '"]').removeClass("active");
        $('[data-faq-question-block="' + settings.oldHandle + '"]').each(function () {
          $(this).removeClass("active");
        });
        $('[data-faq-video="' + settings.oldHandle + '"]').each(function () {
          $(this).removeClass("active");
        });
      }

      $('[data-faq-title="' + handle + '"]').addClass("active");
      $('[data-faq-question-block="' + handle + '"]').each(function () {
        $(this).addClass("active");
      });
      $('[data-faq-video="' + handle + '"]').each(function () {
        $(this).addClass("active");
      });

      $(settings.collectionFiltersOptions).hide();

      settings.oldHandle = handle;
      $(settings.faqContainer).show();
      var height = $(window).height();
      if ($(window).width() < 800) height = height / 2;
      $("body, html").animate({ scrollTop: height - 65 });
    });
  }

  return faq;
})();

var faq = new theme.faq();

function typeAnimation(id, string, reset) {
  var instance = new TypeIt("#typed--" + id);
  if (reset) {
    instance.reset();
  }
  new TypeIt("#typed--" + id, {
    strings: string,
    speed: 100,
    loop: false
  }).go();
}
theme.contact = new (function () {
  var settings = {};

  function contact(contactSettings) {
    var defaultSettings = {
      contactInput: "[data-contact-input]"
    };

    settings = $.extend({}, defaultSettings, contactSettings);

    if ($(".form__input--secondary")[0]) {
      $(settings.contactInput).each(function () {
        $(this).bind("keyup", function () {
          if ($(this).val() == "") {
            $(this).prev().addClass("hide");
          } else {
            $(this).prev().removeClass("hide");
          }
        });

        $(this).on("focus", function () {
          $(this).prev().css("border-bottom", "none");
          $(this).css("border-top", "1px solid black");
        });

        $(this).on("blur", function () {
          $(this).prev().css("border-bottom", "1px solid rgba(21,22,26,0.14)");
          $(this).css("border-top", "none");
        });
      });
    }
  }

  return contact;
})();

var contact = new theme.contact();

theme.account = new (function () {
  var settings = {};

  function account(accountSettings) {
    var defaultSettings = {
      accountOrdersLink: "[data-account-orders-link]",
      accountInfosLink: "[data-account-infos-link]",
      accountInfos: "[data-account-infos]",
      accountOrders: "[data-account-orders]",
      orderDetailsToggle: "[data-order-details-toggle]",
      accountMenus: "[data-account-menus]"
    };

    settings = $.extend({}, defaultSettings, accountSettings);

    $(settings.accountInfosLink).on("click", function () {
      showInformations();
    });

    $(settings.accountOrdersLink).on("click", function () {
      showOrders();
    });

    $(settings.orderDetailsToggle).on("click", function () {
      var $this = $(this);
      toggleOrderDetails($this);
    });

    $(settings.accountMenus).on("change", function () {
      window.location = $(this).val();
    });
  }

  function showInformations() {
    $(settings.accountOrdersLink).removeClass("active");
    $(settings.accountInfosLink).addClass("active");
    $(settings.accountInfos).removeClass("hide");
    $(settings.accountOrders).addClass("hide");
  }

  function showOrders() {
    $(settings.accountInfosLink).removeClass("active");
    $(settings.accountOrdersLink).addClass("active");
    $(settings.accountOrders).removeClass("hide");
    $(settings.accountInfos).addClass("hide");
  }

  function toggleOrderDetails($this) {
    var details = $this.next();
    if (details.hasClass("hide")) {
      $this.next().removeClass("hide");
      $this.addClass("active");
    } else {
      $this.next().addClass("hide");
      $this.removeClass("active");
    }
  }

  return account;
})();

var account = new theme.account();

theme.footer = new (function () {
  var settings = {};

  function footer(footerSettings) {
    var defaultSettings = {
      footerLinksContainer: "[data-footer-links-container]",
      footerLinkTitle: "[data-footer-link-title]"
    };

    settings = $.extend({}, defaultSettings, footerSettings);

    $(settings.footerLinkTitle).on("click", function () {
      if ($(window).width() < 1024) {
        var $container = $(this).closest(settings.footerLinksContainer);
        toggleFooterMenuMobile($container);
      }
    });
  }

  function toggleFooterMenuMobile($container) {
    if ($container.hasClass("active")) {
      $container.removeClass("active");
    } else {
      $(settings.footerLinksContainer).each(function () {
        $(this).removeClass("active");
      });
      $container.addClass("active");
    }
  }

  return footer;
})();

var footer = new theme.footer();

theme.advantages = new (function () {
  var settings = {};

  function advantages(advantagesSettings) {
    var defaultSettings = {
      advantages: "[data-advantages]",
      advantagesOpen: "[data-advantages-open]",
      advantagesClose: "[data-advantages-close]",
      advantagesContainer: "[data-advantages-container]",
      advantagesButton: "[data-advantages-button]"
    };

    settings = $.extend({}, defaultSettings, advantagesSettings);

    $(settings.advantagesOpen).on("click", function () {
      $(settings.advantages).show();
      $(".advantages__price").text($("[data-product-price-recharge]").text());
    });
    $(settings.advantagesClose).on("click", function () {
      $(settings.advantages).hide();
    });
    $(settings.advantagesButton).on("click", function (event) {
      event.preventDefault();
      $(this).css("opacity", 0.2);
      $(this).attr("disabled", true);

      addToCartRecharge();

      setTimeout(function () {
        $(settings.advantagesButton).attr("disabled", false);
        $(settings.advantagesButton).css("opacity", 1);
        $(settings.advantages).hide();
      }, 1000);
    });
  }

  return advantages;
})();

var advantages = new theme.advantages();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
      hideElement: "AddressProvinceContainerNew"
    });
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
    hideAddresses();
  });

  function hideAddresses() {
    $("#address__details").toggleClass("hide");
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  var $currentBlock;
  var $currentFormId;

  var settings = {
    addressesEditBackground: "[data-addresses-edit-background]",
    addressesEditContainer: "[data-addresses-edit-container]",
    addressesEditContent: "[data-addresses-edit-content]",
    addressesContainer: "[data-addresses-container]",
    addressesEditClose: "[data-addresses-edit-close]"
  };

  $(settings.addressesEditClose).on("click", function () {
    closeAddressesEditForm();
  });
  $(settings.addressesEditBackground).on("click", function () {
    closeAddressesEditForm();
  });

  function closeAddressesEditForm() {
    $("body").removeClass("popup--active");
    $(settings.addressesEditContent).removeClass("active");
    $(settings.addressesEditClose).addClass("hide");
    setTimeout(function () {
      $(settings.addressesEditContainer).addClass("hide");
      $("#EditAddress_" + $currentFormId).toggleClass("hide");
      var block = $currentBlock.closest(settings.addressesContainer);
      block.append($("#EditAddress_" + $currentFormId));
    }, 400);
  }

  $(".address-edit-toggle").on("click", function () {
    $("body").addClass("popup--active");
    var formId = $(this).data("form-id");

    $currentBlock = $(this);
    $currentFormId = formId;

    $("#EditAddress_" + formId).toggleClass("hide");

    $(settings.addressesEditContent).empty();
    $(settings.addressesEditContent).append($("#EditAddress_" + formId));
    setTimeout(function () {
      $(settings.addressesEditContent).addClass("active");
      $(settings.addressesEditClose).removeClass("hide");
    }, 100);
    $(settings.addressesEditContainer).removeClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" }
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink"
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper"
  });

  // Target iframes to make them responsive
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper"
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
  }
});

function show(e) {
  var searchbar = e.querySelector(".searchbar-input");
  searchbar.classList.add("is-active");
}

document.querySelectorAll("div#y-badges")[1].setAttribute("style", "background-color:black !important");
document.querySelectorAll("div#y-badges")[0].setAttribute("style", "background-color:black !important");

function resizeCart() {
  var cartHeaderHeight = document.querySelector(".cart-header").offsetHeight;
  var freeShippingHeight = document.querySelector(".free-shipping__container").offsetHeight;
  var relatedProductHeight = document.querySelector(".cart-addition").offsetHeight;
  var cartFooterHeight = document.querySelector(".cart-footer__content").offsetHeight;
  var windowHeight = window.innerHeight;
  var cartHeight = windowHeight - cartHeaderHeight - freeShippingHeight - relatedProductHeight - cartFooterHeight;
  $("#cart-items__result").css("max-height", cartHeight);
  $("#cart-items__result").css("height", cartHeight);
}

resizeCart();

window.addEventListener("resize", (e) => {
  resizeCart();
});

$("body").on("click", ".angle-down-btn", function (e) {
  e.preventDefault();
  $(this).closest(".cart__row-parent").toggleClass("active");
  var cart_parent_id = $(this).closest(".cart__row-parent").data("id");
  $(".cart_child_" + cart_parent_id).slideToggle();
});
